import React, { Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';
import PrivateRoute, { PublicRoute } from './PrivateRoute';
import DetailsPrivateRoute from './DetailsPrivateRoute';
import AdminPrivateRoute from './AdminPrivateRoute';

import MainSeatingDashboard from '../../components/vendorDashboardComponents/seatingDashboard/MainSeatingDashboard';
import Event from '../../components/vendorDashboardComponents/events/Event';
import Offer from '../../components/vendorDashboardComponents/offers/Offer';
// import NotificationComponent from '../../components/vendorDashboardComponents/notification/NotificationComponent';
import Notification from '../../components/vendorDashboardComponents/notification/Notification';
import EditProfile from '../../components/vendorDashboardComponents/editProfileScreen/EditProfile';
import CustomersBusiness from '../../components/vendorDashboardComponents/customersBusinessScreen/CustomersBusiness';
import LiveStreamingSession from '../../components/vendorDashboardComponents/customersBusinessScreen/LiveStreamingSession';
import DisplayPage from '../../components/vendorDashboardComponents/DisplayPage';
import MainPendingDashboard from '../../components/vendorDashboardComponents/seatingDashboard/MainPendingDashboard';
import MainReservation from '../../components/vendorDashboardComponents/seatingDashboard/MainReservation';
import MainHistoryDashboard from '../../components/vendorDashboardComponents/seatingDashboard/MainHistoryDashboard';
import MainReportsDashboard from '../../components/vendorDashboardComponents/reportsDashboard/MainReportsDashboard';
import VendorOpenIssuesMainSuggestion from '../../components/vendorDashboardComponents/vendorOpenIssuesSuggestions/VendorOpenIssuesMainSuggestion';
import VendorUserOpenIssuesView from '../../components/vendorDashboardComponents/openIssuesVendor/VendorUserOpenIssuesView';
import VendorOpenIssuesSuggestionView from '../../components/vendorDashboardComponents/vendorOpenIssuesSuggestions/VendorOpenIssuesSuggestionView';
import VendorRatingReviewsComponent from '../../components/vendorDashboardComponents/reviewsVendors/VendorRatingReviewsComponent';
import OpenIssuesVendor from '../../components/vendorDashboardComponents/openIssuesVendor/OpenIssuesVendor';
import VendorOpenIssuesSuggestionEdit from '../../components/vendorDashboardComponents/vendorOpenIssuesSuggestions/VendorOpenIssuesSuggestionEdit';
import VendorOpenIssuesTicketEdit from '../../components/vendorDashboardComponents/openIssuesVendor/VendorOpenIssuesTicketEdit';
import OrderRequest from '../../components/vendorDashboardComponents/Orders/OrderRequest/OrderRequest';
import SubstituteItem from '../../components/vendorDashboardComponents/Orders/OrderRequest/SubstituteItem';
import EditPageAddNewItem from '../../components/vendorDashboardComponents/Orders/OrderRequest/EditPageAddNewItem';
import OrderPayment from '../../components/vendorDashboardComponents/Orders/OrderPayment';
import EditAddItemPayment from '../../components/vendorDashboardComponents/Orders/EditAddItemPayment';
import ReOrderPayment from '../../components/vendorDashboardComponents/Orders/ReOrderPayment';
import OrderPaymentSubstitute from '../../components/vendorDashboardComponents/Orders/OrderPaymentSubstitute';
import OrderTrack from '../../components/vendorDashboardComponents/Orders/OrderTrack/OrderTrack';
import OrderDashboard from '../../components/vendorDashboardComponents/Orders/OrderDashboard/OrderDashboard';
import Payment from '../../components/vendorDashboardComponents/Orders/OrderDashboard/Payment';
import AddOrder from '../../components/vendorDashboardComponents/Orders/OrderDashboard/AddOrder';
import ItemAvailability from '../../components/vendorDashboardComponents/ItemAvailability/ItemAvailability';
import AddItemAvailability from '../../components/vendorDashboardComponents/ItemAvailability/AddItemAvailability';
import CategoryDashboard from '../../components/vendorDashboardComponents/CategoryDashboard/CategoryDashboard';
import OfflineEventDetails from '../../components/vendorDashboardComponents/events/OfflineEventDetails/OfflineEventDetails';
import OfflineEventsPending from '../../components/vendorDashboardComponents/events/OfflineEventDetails/OfflineEventsPending';
import OfflineEventsBooked from '../../components/vendorDashboardComponents/events/OfflineEventDetails/OfflineEventsBooked';
import OfflineEventsHistory from '../../components/vendorDashboardComponents/events/OfflineEventDetails/OfflineEventsHistory';
import OfflineEventAll from '../../components/vendorDashboardComponents/events/OfflineEventDetails/OfflineEventAll';
import AddEvent from '../../components/vendorDashboardComponents/events/OfflineEventDetails/AddEvent/AddEvent';
import ManageBlockReservationCalender from '../../components/vendorDashboardComponents/customersBusinessScreen/ManageBlockReservationCalender/ManageBlockReservationCalender';
import BlockDateOrSlot from '../../components/vendorDashboardComponents/customersBusinessScreen/ManageBlockReservationCalender/BlockDateOrSlot';
import AllReservations from '../../components/vendorDashboardComponents/customersBusinessScreen/ManageBlockReservationCalender/AllReservations';
import VendorReferrals from '../../components/vendorDashboardComponents/referrals/VendorReferrals';
import EventPayment from '../../components/vendorDashboardComponents/events/EventPayment/EventPayment';

/*****************************
 * @DESC Edit Screen Start
 ****************************/

import VendorMapSetupEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/mapSetupEditScreen/VendorMapSetupEdit';
import VendorRestaurantDetailsEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/restaurantDetailsEditScreen/VendorRestaurantDetailsEdit';
import VendorRestaurantDetailsLogoImage from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/restaurantDetailsEditScreen/VendorRestaurantDetailsLogoImage';
import VendorPointOfContactsEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/pointOfContactsEditScreen/VendorPointOfContactsEdit';
import VendorRestaurantChainEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/restaurantChainEditScreen/VendorRestaurantChainEdit';
import VendorRestaurantTypeEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/restaurantTypeEditScreen/VendorRestaurantTypeEdit';
import VendorPaymentMethodEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/paymentMethodEditScreen/VendorPaymentMethodEdit';
import VendorDressCodeEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/dressCodeEditScreen/VendorDressCodeEdit';
import VendorPetsAllowedEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/petsAllowedEditScreen/VendorPetsAllowedEdit';
import VendorLocatedInsideEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/locatedInsideEditScreen/VendorLocatedInsideEdit';
import VendorHealthAndSenitationEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/healthAndSenitation/VendorHealthAndSenitationEdit';
import VendorHealthAndSenitationFacilityEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/healthAndSenitation/VendorHealthAndSenitationFacilityEdit';
import VendorHealthAndSenitationEmployeesEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/healthAndSenitation/VendorHealthAndSenitationEmployeesEdit';
import VendorHealthAndSenitationFoodHandlingEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/healthAndSenitation/VendorHealthAndSenitationFoodHandlingEdit';
import VendorHealthAndSenitationHealthSafetyEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/healthAndSenitation/VendorHealthAndSenitationHealthSafetyEdit';
import VendorHealthAndSenitationProtocol from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/healthAndSenitation/VendorHealthAndSenitationProtocol';
import VendorParkingEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/parkingEditScreen/VendorParkingEdit';
import VendorAccessibilityTypeEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/accessibilityEditScreen/VendorAccessibilityTypeEdit';
import VendorOtherFeaturesEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/otherFeaturesEditScreen/VendorOtherFeaturesEdit';
import VendorServiceOfferedEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/serviceOfferedEditScreen/VendorServiceOfferedEdit';
import VendorFoodTypeEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/foodTypeEditScreen/VendorFoodTypeEdit';
import VendorCuisineOfferedEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/cuisineOfferedEditScreen/VendorCuisineOfferedEdit';
import CategoryAndLiquorEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/categoryAndLiquorEditScreen/CategoryAndLiquorEdit';
import EditPointOfSaleScreen from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/pointOfSaleEditScreen/EditPointOfSaleScreen';
import VendorBusinessHoursEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/businessHoursEditScreen/VendorBusinessHoursEdit';
import VendorBankDetailsEdit from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/bankDetailsEditScreen/VendorBankDetailsEdit';
import SeatingAreaEditScreen from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/SubscriptionEditPageScreen/SeatingAreaEditScreen';
import GenralEditScreen from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/SubscriptionEditPageScreen/GenralEditScreen';
import WalkinWaitlistSubscriptionEditScreen from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/SubscriptionEditPageScreen/WalkinWaitlistSubscriptionEditScreen';
import ReservationSubscriptionEditScreen from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/SubscriptionEditPageScreen/ReservationSubscriptionEditScreen';
import CasualDiningEditOffersManagement from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/OffersManagement/CasualDiningEditOffersManagement';
import FastFoodEditOffersManagement from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/FastFoodManagementScreen/OffersManagement/FastFoodEditOffersManagement';

/*****************************
 * @DESC Edit Screen End
 ****************************/

import SuperAdminMainHomeComponent from '../../components/superAdminComponents/superAdminAllComponent/superAdminHome/SuperAdminMainHomeComponent';
import MainSuperAdminUsers from '../../components/superAdminComponents/superAdminAllComponent/superAdminUsers/MainSuperAdminUsers';

import SuperAdminMainListOfIcon from '../../components/superAdminComponents/superAdminAllComponent/superAdminListOfIcon/SuperAdminMainListOfIcon';
import SuperAdminRatingReviews from '../../components/superAdminComponents/superAdminAllComponent/superAdminRatingReviews/SuperAdminRatingReviews';
import SuperAdminSuggestion from '../../components/superAdminComponents/superAdminAllComponent/superAdminSuggestion/SuperAdminSuggestion';
import SuperAdminMainNominations from '../../components/superAdminComponents/superAdminAllComponent/superAdminNominations/SuperAdminMainNominations';
import SuperAdminOpenIssuesUsers from '../../components/superAdminComponents/superAdminAllComponent/superAdminOpenIssuesUsers/SuperAdminOpenIssuesUsers';
import SuperAdminOpenIssuesVendor from '../../components/superAdminComponents/superAdminAllComponent/superAdminOpenIssuesVendor/SuperAdminOpenIssuesVendor';
import SuperAdminReportsMain from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/SuperAdminReportsMain';
import SuperAdminAllUsersView from '../../components/superAdminComponents/superAdminAllComponent/superAdminUsers/insideComponent/SuperAdminAllUsersView';
import SuperAdminMainVendorComponent from '../../components/superAdminComponents/superAdminAllComponent/superAdminVendor/superAdminVendorTable/SuperAdminMainVendorComponent';
import VendorRatingReviewDisplayPage from '../../components/superAdminComponents/superAdminAllComponent/superAdminVendor/superAdminVendorInsidePage/VendorRatingReviewDisplayPage';
import VendorRatingReviewProfile from '../../components/superAdminComponents/superAdminAllComponent/superAdminVendor/superAdminVendorInsidePage/VendorRatingReviewProfile';
import SuperAdminReferralsCode from '../../components/superAdminComponents/superAdminAllComponent/superAdminRefferalsCode/SuperAdminReferralsCode';
import SuperAdminMainUserFavorites from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminUserFavorites/SuperAdminMainUserFavorites';
import SuperAdminUserViewUsed from '../../components/superAdminComponents/superAdminAllComponent/superAdminUserViewUsed/SuperAdminUserViewUsed';
import salesRepresentativedashboard from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminSalesRepresentativeDashboard/SalesRepresentativedashboard';
import PosDetails from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminPosSettings/PosDetails';
import DunzoDeliverySettings from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminDunzo/DunzoDeliverySettings';
import AddDunzoPartners from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminDunzo/AddDunzoPartners';
import DunzoStatement from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminDunzo/DunzoStatement';
import DunzoStatements from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminDunzo/DunzoStatements';
import SuperAdminOffers from '../../components/superAdminComponents/superAdminAllComponent/superAdminOffers/SuperAdminOffers';
import AffiliatesDashboard from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAffiliatesDashboard/AffiliatesDashboard';
import SuperAdminPartnersDashboard from '../../components/superAdminComponents/superAdminAllComponent/superAdminPartnerDashboard/SuperAdminPartnersDashboard';
import AddNewOffer from '../../components/superAdminComponents/superAdminAllComponent/superAdminOffers/AddNewOffer/AddNewOffer';
import AdminAddNewOffer from '../../components/superAdminComponents/superAdminAllComponent/superAdminOffers/AddNewOffer/AdminAddNewOffer';
import EditAdminOfflineOffer from '../../components/superAdminComponents/superAdminAllComponent/superAdminOffers/EditOffer/EditAdminOfflineOffer';
import EditOfflineOffer from '../../components/superAdminComponents/superAdminAllComponent/superAdminOffers/EditOffer/EditOfflineOffer';
import EditOnlineOffer from '../../components/superAdminComponents/superAdminAllComponent/superAdminOffers/EditOffer/EditOnlineOffer';
import SuperAdminNominatioViewPage from '../../components/superAdminComponents/superAdminAllComponent/superAdminNominations/NominationInsideViewPage/SuperAdminNominatioViewPage';
import SuperAdminNominationViewActivity from '../../components/superAdminComponents/superAdminAllComponent/superAdminNominations/NominationInsideViewPage/SuperAdminNominationViewActivity';
import SuperAdminViewUsersTickets from '../../components/superAdminComponents/superAdminAllComponent/superAdminOpenIssuesUsers/ViewUsersTickets/SuperAdminViewUsersTickets';
import SuperAdminViewVendorsTickets from '../../components/superAdminComponents/superAdminAllComponent/superAdminOpenIssuesVendor/ViewVendorsTickets/SuperAdminViewVendorsTickets';
// import SuperAdminEditVendorsTickets from "../../components/superAdminComponents/superAdminAllComponent/superAdminOpenIssuesVendor/ViewVendorsTickets/SuperAdminEditVendorsTickets";
import SuperAdminPendingVendorsComponent from '../../components/superAdminComponents/superAdminAllComponent/superAdminPendingVendors/SuperAdminPendingVendorsComponent';
import SuperAdminRestaurantOffers from '../../components/superAdminComponents/superAdminAllComponent/superAdminRestaurantOffers/SuperAdminRestaurantOffers';
import SuperAdminOrders from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminOrders/SuperAdminOrders';
import SuperAdminCreateOrders from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminOrders/SuperAdminCreateOrders';
import SuperAdminEventManagement from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminEventManagement/SuperAdminEventManagement';
import SuperAdminVendorOrdersPrivate from '../../components/superAdminComponents/superAdminAllComponent/superAdminVendorOrdersPrivate/SuperAdminVendorOrdersPrivate';
import SuperAdminOfflineEventDetails from '../../components/superAdminComponents/superAdminAllComponent/superAdminEventsVendor/SuperAdminOfflineEventDetails';
import SuperAdminRefrees from '../../components/superAdminComponents/superAdminAllComponent/superAdminRefferalsCode/SuperAdminRefrees/SuperAdminRefrees';
import SuperAdminReferrals from '../../components/superAdminComponents/superAdminAllComponent/superAdminRefferalsCode/SuperAdminReferrals/SuperAdminReferrals';
import SuperAdminOrderReports from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/orderingReports/SuperAdminOrderReports';
import SuperAdminPendingChainsVendor from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminChainsVendor/SuperAdminPendingChainsVendor';
import SuperAdminActiveChainsVendor from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminChainsVendor/SuperAdminActiveChainsVendor';
import SuperAdminAddChainsVendor from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminChainsVendor/SuperAdminAddChainsVendor';
import SuperAdminAddGlobalCatalogue from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminGlobalCatalogue/SuperAdminAddGlobalCatalogue/SuperAdminAddGlobalCatalogue';
import { SuperAdminGlobalCatalogue } from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminGlobalCatalogue/SuperAdminGlobalCatalogue';
import { SuperAdminAddChainCatalogue } from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminGlobalCatalogue/SuperAdminChainCatalogue/SuperAdminAddChainCatalogue';
import AssignItem from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminGlobalCatalogue/SuperAdminCatalogueView/AssignItem';
import AssignChainItem from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminGlobalCatalogue/SuperAdminCatalogueView/AssignChainItem';
import SuperAdminCatalogueView from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminGlobalCatalogue/SuperAdminCatalogueView/SuperAdminCatalogueView';
import AddItemCatalogue from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminGlobalCatalogue/SuperAdminCatalogueView/AddItemCatalogue';
import AddItemChain from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminGlobalCatalogue/SuperAdminChainCatalogue/AddItemChain';
import SuperAdminGlobalItemsManagement from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminGlobalCatalogue/SuperAdminGlobalItemsManagement/SuperAdminGlobalItemsManagement';
import SuperAdminGlobalAddCategory from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminGlobalCatalogue/SuperAdminGlobalItemsManagement/SuperAdminGlobalAddCategory';
import SuperAdminChainItemsManagement from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminGlobalCatalogue/SuperAdminChainCatalogue/SuperAdminChainItemsManagement';
import SuperAdminEventTicketActivity from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminEventTicketActivity/SuperAdminEventTicketActivity';
import MarketingAndPromotionsDashbard from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminMarketingAndPromotions/MarketingAndPromotionsDashbard';
/*************************************************
 * @DESC Vendor Onboarding Process
 ************************************************/
// import MainMapSetupComponent from './components/vendorOnboradingComponents/allScreens/mapSetupOnboardingComponent/MainMapSetupComponent';
// import MapSetupAutoComponent from './components/vendorOnboradingComponents/allScreens/mapSetupOnboardingComponent/MapSetupAutoComponent';
import RestaurantDetailsSettings from '../../components/vendorOnboradingComponents/allScreens/restaurantDetailsOnboarding/RestaurantDetailsSettings';
import PointOfContactsComponent from '../../components/vendorOnboradingComponents/allScreens/pointOfContacts/PointOfContactsComponent';
import RestaurantChainsOnboardingComponent from '../../components/vendorOnboradingComponents/allScreens/restaurantChains/RestaurantChainsOnboardingComponent';
import RestaurantTypeComponent from '../../components/vendorOnboradingComponents/allScreens/restaurantType/RestaurantTypeComponent';
import PaymentMethodOnboarding from '../../components/vendorOnboradingComponents/allScreens/paymentMethod/PaymentMethodOnboarding';
import DressCodeOnboarding from '../../components/vendorOnboradingComponents/allScreens/dressCode/DressCodeOnboarding';
import LocatedInsideOnboarding from '../../components/vendorOnboradingComponents/allScreens/locatedInside/LocatedInsideOnboarding';
import PointOfSaleComponent from '../../components/vendorOnboradingComponents/allScreens/pointOfSaleComponent/PointOfSaleComponent';
import HealthAndSenitationOnboardingComponent from '../../components/vendorOnboradingComponents/allScreens/healthAndSenitation/HealthAndSenitationOnboardingComponent';
import ParkingMethodOnboarding from '../../components/vendorOnboradingComponents/allScreens/parkingComponent/ParkingMethodOnboarding';
import AccessibilityOnboardingComponent from '../../components/vendorOnboradingComponents/allScreens/accessibilityComponent/AccessibilityOnboardingComponent';
import OtherFeaturesOnboarding from '../../components/vendorOnboradingComponents/allScreens/otherFeaturesComponent/OtherFeaturesOnboarding';
import ServicesOfferedOnboarding from '../../components/vendorOnboradingComponents/allScreens/servicesOffered/ServicesOfferedOnboarding';
import CuisineSetupOnboarding from '../../components/vendorOnboradingComponents/allScreens/cuisineFeaturesComponent/CuisineSetupOnboarding';
import BankAndOtherDetails from '../../components/vendorOnboradingComponents/allScreens/bankandOtherDetails/BankAndOtherDetails';
import MainSubscriptionComponent from '../../components/vendorOnboradingComponents/allScreens/subscriptionScreen/MainSubscriptionComponent';
import FoodTypeComponent from '../../components/vendorOnboradingComponents/allScreens/foodTypeComponent/FoodTypeComponent';
import CuisineOfferedComponent from '../../components/vendorOnboradingComponents/allScreens/cuisineOfferedComponent/CuisineOfferedComponent';
import MainBusinessHours from '../../components/vendorOnboradingComponents/allScreens/businessandHoursofOperations/MainBusinessHours';
import PetsAllowedComponent from '../../components/vendorOnboradingComponents/allScreens/petsAllowedComponent/PetsAllowedComponent';
import NoMapSetupComponent from '../../components/vendorOnboradingComponents/allScreens/mapSetupOnboardingComponent/InsideMenuPage/noMapSetup/NoMapSetupComponent';
import MapSetupScreenOne from '../../components/vendorOnboradingComponents/allScreens/MapSetup/MapSetupScreenOne';
import MapSetupScreenTwo from '../../components/vendorOnboradingComponents/allScreens/MapSetup/MapSetupScreenTwo';
import MainSubscriptionScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/MainSubscriptionScreen';

/************************************
 * @DESC MULTI SERVICE SUBSCRIPTION
 *************************************/

import MultiServiceOffersManagement from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/OffersManagement/MultiServiceOffersManagement';
import MultiServiceScanAndPayScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/ScanAndPayManagement/MultiServiceScanAndPayScreen';
import MultiServiceEventManagementScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/EventsManagement/MultiServiceEventManagementScreen';
import MultiServiceOnlineEventsSubscription from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/EventsManagement/OnlineEvents';
import MultiServiceOfflineEventsSubscription from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/EventsManagement/OfflineEvents';
import MultiServiceTicketBookingPayment from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/EventsManagement/TicketBookingPayment';
import MultiServiceLiveStreamingScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/CasualDiningLiveStreamingManagement/CasualDiningLiveStreamingScreen';
import MultiServiceSeatingManagementScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/SeatingManagement/MultiServiceSeatingManagementScreen';
import MultiServiceGenralSeatingScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/SeatingManagement/MultiServiceGenralSeatingScreen';
import MultiServiceWalkinWaitlistScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/SeatingManagement/MultiServiceWalkinWaitlistScreen';
import MultiServiceReservationSeatingScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/SeatingManagement/MultiServiceReservationSeatingScreen';
import MultiServiceTableManagementScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/SeatingManagement/MultiServiceTableManagementScreen';
import MultiServiceTableSeatManagement from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/SeatingManagement/MultiServiceTableSeatManagement';
import MultiServiceOrderingScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/OrderingManagement/MultiServiceOrderingScreen';
import MultiServiceTakeaway from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/OrderingManagement/SubPages/MultiServiceTakeaway';
import MultiServiceCurbside from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/OrderingManagement/SubPages/MultiServiceCurbside';
import MultiServiceDinein from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/OrderingManagement/SubPages/MultiServiceDinein';
import MultiServiceSkipTheLine from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/OrderingManagement/SubPages/MultiServiceSkipTheLine';
import MultiServiceAtMySeatTable from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/OrderingManagement/SubPages/MultiServiceAtMySeatTable';
import MultiServiceDineinTableManagementScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/OrderingManagement/SubPages/MultiServiceDineinTableManagementScreen';
import MultiServiceDineinTableSeatManagement from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/OrderingManagement/SubPages/MultiServiceDineinTableSeatManagement';
import MultiServiceCateringBanquet from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/OrderingManagement/SubPages/MultiServiceCateringBanquet';
import MultiServiceCateringRoomManagementScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/OrderingManagement/SubPages/MultiServiceCateringRoomManagementScreen';
import MultiServiceCateringRoomSeatManagement from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/OrderingManagement/SubPages/MultiServiceCateringRoomSeatManagement';
import MultiServiceHomeDelivery from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/OrderingManagement/SubPages/MultiServiceHomeDelivery';
import MultiServiceBankAccount from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/OrderingManagement/SubPages/MultiServiceBankAccount';
import MultiServiceSeparateBankAccount from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/OrderingManagement/SubPages/MultiServiceSeparateBankAccount';
import MultiServiceGeneralSettingsTaxes from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/MultiServiceManagementScreen/OrderingManagement/SubPages/MultiServiceGeneralSettingsTaxes';

import Login from '../../components/authentication/login/Login';
import AdminOtpComponent from '../../components/authentication/AdminOtpAuth/AdminOtpComponent';

import SignUp from '../../components/authentication/signUp/SignUp';
import ForgotPassword from '../../components/authentication/forgotPassword/ForgotPassword';
import Otp from '../../components/authentication/otp/Otp';
import ResetPassword from '../../components/authentication/resetPassword/ResetPassword';
import ResetPasswordSuccess from '../../components/authentication/resetPassword/ResetPasswordSuccess';

import PageNotFound from '../../components/PageNotFound/PageNotFound';

import HelpPageComponent from '../../components/authentication/helpPage/HelpPageComponent';
import RestaurantDetailsLogoVideo from '../../components/vendorOnboradingComponents/allScreens/restaurantDetailsLogoVideo/RestaurantDetailsLogoVideo';
import AddUser from '../../components/superAdminComponents/superAdminAllComponent/superAdminUsers/AddUser';
import SuperAdminMainUserFavoritesGroup from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminUserFavorites/SuperAdminMainUserFavoritesGroup';
import SuperAdminMainUserFavoritesGroupRestaurant from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminUserFavorites/SuperAdminMainUserFavoritesGroupRestaurant';
import SuperAdminMainUserFavoritesGroupOffer from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminUserFavorites/SuperAdminMainUserFavoritesGroupOffer';
import SuperAdminMainUserFavoritesGroupEvent from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminUserFavorites/SuperAdminMainUserFavoritesGroupEvent';
import SuperAdminAddVendorSignup from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/SuperAdminAddVendorSignup';
import SuperAdminAddMapDetails from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/MapSetup/SuperAdminAddMapDetails';
import SuperAdminAddMapDetailsTwo from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/MapSetup/SuperAdminAddMapDetailsTwo';
import SuperAdminAddBusinessDetails from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/restaurantDetailsOnboarding/SuperAdminAddBusinessDetails';
import SuperAdminAddPointOfContact from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/pointOfContacts/SuperAdminAddPointOfContact';
import SuperAdminAddRestaurantDetails from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/restaurantDetailsLogoVideo/SuperAdminAddRestaurantDetails';
import SuperAdminRestaurantChain from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/restaurantChains/SuperAdminRestaurantChain';
import SuperAdminRestaurantTypeComponent from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/restaurantType/SuperAdminRestaurantTypeComponent';
import SuperAdminVendorPaymentMethod from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/paymentMethod/SuperAdminVendorPaymentMethod';
import SuperAdminVendorParking from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/parkingComponent/SuperAdminVendorParking';
import SuperAdminVendorPetsAllowed from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/petsAllowedComponent/SuperAdminVendorPetsAllowed';
import SuperAdminVendorDressCode from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/dressCode/SuperAdminVendorDressCode';
import SuperAdminVendorAccessiblity from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/accessibilityComponent/SuperAdminVendorAccessiblity';
import SuperAdminVendorOtherFeatures from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/otherFeaturesComponent/SuperAdminVendorOtherFeatures';
import SuperAdminVendorServiceOffered from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/servicesOffered/SuperAdminVendorServiceOffered';
import SuperAdminVendorLocatedInside from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/locatedInside/SuperAdminVendorLocatedInside';
import SuperAdminVendorPointOfSale from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/pointOfSaleComponent/SuperAdminVendorPointOfSale';
import SuperAdminVendorHealthAndSenitation from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/healthAndSenitation/SuperAdminVendorHealthAndSenitation';
import SuperAdminVendorCuisineSetup from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/cuisineFeaturesComponent/SuperAdminVendorCuisineSetup';
import SuperAdminVendorFoodType from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/foodTypeComponent/SuperAdminVendorFoodType';
import SuperAdminVendorCuisineOffered from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/cuisineOfferedComponent/SuperAdminVendorCuisineOffered';
import SuperAdminVendorBusinessHours from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/businessandHoursofOperations/SuperAdminVendorBusinessHours';
import SuperAdminVendorBankDetails from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/bankandOtherDetails/BankAndOtherDetails';
import SuperAdminVendorSubscription from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/subscriptionScreen/SuperAdminVendorSubscription';
import MainSeatingComponent from '../../components/superAdminComponents/superAdminAllComponent/superAdminVendor/superAdminVendorDashboardComponet/MainSeatingComponent';
import AdminAddDiner from '../../components/superAdminComponents/superAdminAllComponent/superAdminVendor/superAdminVendorDashboardComponet/AdminAddDiner';
import SuperAdminReferralRewarddashboard from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminReferralRewardDashboard/SuperAdminReferralRewarddashboard';
import EditReferralReward from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminReferralRewardDashboard/EditReferralReward';
import SuperAdminValidatereferralrewardprogram from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminReferralRewardDashboard/SuperAdminValidatereferralrewardprogram';
import SuperAdminApprovedreferrals from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminReferralRewardDashboard/SuperAdminApprovedreferrals';
import AddRefferalprogram from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminReferralRewardDashboard/AddRefferalprogram';
import SuperAdminRestaurantEvents from '../../components/superAdminComponents/superAdminAllComponent/superAdminRestaurantEvents/SuperAdminRestaurantEvents';
import AddNewEvent from '../../components/superAdminComponents/superAdminAllComponent/superAdminRestaurantEvents/AddNewEvent/AddNewEvent';
import EditOfflineEvent from '../../components/superAdminComponents/superAdminAllComponent/superAdminRestaurantEvents/EditEvent/EditOfflineEvent';
import EditOnlineEvent from '../../components/superAdminComponents/superAdminAllComponent/superAdminRestaurantEvents/EditEvent/EditOnlineEvent';
import SuperAdminScanPay from '../../components/superAdminComponents/superAdminAllComponent/superAdminScanPay/SuperAdminScanPay';
import SuperAdminUserWallatTransactions from '../../components/superAdminComponents/superAdminAllComponent/superAdminUserWallatTransactions/SuperAdminUserWallatTransactions';
import SuperAdminDonationReport from '../../components/superAdminComponents/superAdminAllComponent/superAdminDonation/SuperAdminDonationReport';
import SuperAdminDonationDetails from '../../components/superAdminComponents/superAdminAllComponent/superAdminDonation/SuperAdminDonationDetails';
import SuperAdminDonation from '../../components/superAdminComponents/superAdminAllComponent/superAdminDonation/SuperAdminDonation';
import AddDiner from '../../components/vendorDashboardComponents/seatingDashboard/AddDiner';
import VendorEditOfflineOffer from '../../components/vendorDashboardComponents/offers/EditOffer/VendorEditOfflineOffer';
import VendorEditOnlineOffer from '../../components/vendorDashboardComponents/offers/EditOffer/VendorEditOnlineOffer';
import AddNewEventVendor from '../../components/vendorDashboardComponents/events/AddNewEventVendor/AddNewEventVendor';
import VendorEditOfflineEvent from '../../components/vendorDashboardComponents/events/EditEvent/VendorEditOfflineEvent';
import VendorEditOnlineEvent from '../../components/vendorDashboardComponents/events/EditEvent/VendorEditOnlineEvent';
import OffersReportsDetails from '../../components/vendorDashboardComponents/reportsDashboard/offerReports/OffersReportsDetails';
import EventsReportsDetails from '../../components/vendorDashboardComponents/reportsDashboard/eventReports/EventsReportsDetails';
import QRCodeView from '../../components/vendorDashboardComponents/QRCodeView/QRCodeView';
import ReferralQrcodeView from '../../components/vendorDashboardComponents/QRCodeView/ReferralQrcodeView';
import VendorProfile from '../../components/vendorDashboardComponents/editProfileScreen/VendorProfile';
import OnlineEventDetails from '../../components/vendorDashboardComponents/events/OnlineEventDetails';
import CasualDiningOrderingScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/CasualDiningOrderingScreen';
import MenuSetup from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/MenuSetup';
import Cuisine from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/SelectMenu/Cuisine';
import CategoryType from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/SelectMenu/CategoryType';
import CrossSelling from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/CrossSelling';
import SelectedCategories from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/SelectMenu/SelectedCategories';
import SelectedItemsNew from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/SelectMenu/SelectedItemsNew';
import { EditCategories } from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/SelectMenu/EditCategories';
import SelectItems from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/SelectMenu/SelectItems';
import SelectItemsNew from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/SelectMenu/SelectItemsNew';
import { SelectedItems } from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/SelectMenu/SelectedItems';
import { UploadMenu } from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/UploadMenu/UploadMenu';
import AddCategories from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/AddCategories';
import AddItem from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/AddItem/AddItem';
import Takeaway from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/Takeaway';
import Curbside from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/Curbside';
import Dinein from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/Dinein';
import DineinTableManagementScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/DineinTableManagementScreen';
import DineinTableSeatManagement from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/DineinTableSeatManagement';
import CateringBanquet from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/CateringBanquet';
import CateringRoomSeatManagement from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/CateringRoomSeatManagement';
import CateringRoomManagementScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/CateringRoomManagementScreen';
import HomeDelivery from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/HomeDelivery';
import BankAccount from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/BankAccount';
import GeneralSettingsTaxes from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/GeneralSettingsTaxes';
import { SuperAdminMainComponent } from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminOrderingComponent/SuperAdminMainComponent';
import AddOfferNewVendor from '../../components/vendorDashboardComponents/offers/AddOfferScreen/AddOfferNewVendor';
import TableSeatManagement from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/SeatingManagement/TableSeatManagement';
import TableManagementScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/SeatingManagement/TableManagementScreen';
import SeparateBankAccount from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/SeparateBankAccount';
import TermsAndCondition from '../../components/vendorOnboradingComponents/allScreens/termsAndConditions/TermsAndCondition';

import RoleManagement from '../../components/vendorDashboardComponents/roleManagement/RoleManagement';
import AdminTermsAndConditions from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/termsAndConditions/AdminTermsAndConditions';
import AddRole from '../../components/vendorDashboardComponents/roleManagement/AddRole';
import { ManageHoursOperation } from '../../components/vendorDashboardComponents/manageHoursOperation/ManageHoursOperation';
// import SuperAdminRefrees from "../../components/superAdminComponents/superAdminAllComponent/superAdminRefferalsCode/SuperAdminRefrees/SuperAdminRefrees";
// import SuperAdminReferrals from "../../components/superAdminComponents/superAdminAllComponent/superAdminRefferalsCode/SuperAdminReferrals/SuperAdminReferrals";
import CasualDiningOffersManagement from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OffersManagement/CasualDiningOffersManagement';
import CasualDiningLiveStreamingScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/CasualDiningLiveStreamingManagement/CasualDiningLiveStreamingScreen';
import CasualDiningSeatingManagementScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/SeatingManagement/CasualDiningSeatingManagementScreen';
import GenralSeatingScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/SeatingManagement/GenralSeatingScreen';
import WalkinWaitlistScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/SeatingManagement/WalkinWaitlistScreen';
import ReservationSeatingScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/SeatingManagement/ReservationSeatingScreen';
import VendorDashboardAddcategory from '../../components/vendorDashboardComponents/CategoryDashboard/Addcategory/VendorDashboardAddcategory';
import PendingVendorRatingReviewProfile from '../../components/superAdminComponents/superAdminAllComponent/superAdminPendingVendors/superAdminVendorInsidePage/VendorRatingReviewProfile';
import CasualDiningEventManagementScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/EventsManagement/CasualDiningEventManagementScreen';
import OnlineEventsSubscription from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/EventsManagement/OnlineEvents';
import OfflineEventsSubscription from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/EventsManagement/OfflineEvents';
import OfflineExperienceSubscription from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/ExperienceManagement/OfflineExperience';
import CasualDiningScanAndPayScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/ScanAndPayManagement/CasualDiningScanAndPayScreen';
import TicketBookingPayment from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/EventsManagement/TicketBookingPayment';
import FastFoodOffersManagement from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/OffersManagement/FastFoodOffersManagement';
import FastFoodScanAndPayScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/ScanAndPayManagement/FastFoodScanAndPayScreen';
import FastFoodLiveStreamingScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/FastFoodLiveStreamingManagement/FastFoodLiveStreamingScreen';
import FastFoodOrderingScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/OrderingManagement/FastFoodOrderingScreen';
import FastFoodTakeaway from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodTakeaway';
import FastFoodCurbside from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodCurbside';
import FastFoodDinein from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodDinein';
import FastFoodHomeDelivery from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodHomeDelivery';
import FastFoodSeparateBankAccount from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodSeparateBankAccount';
import FastFoodBankAccount from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodBankAccount';
import FastFoodCateringBanquet from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodCateringBanquet';
import FastFoodGeneralSettingsTaxes from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodGeneralSettingsTaxes';
import FastFoodMenuSetup from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/MenuSetup/FastFoodMenuSetup';
import FastFoodCuisine from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/MenuSetup/SelectMenu/FastFoodCuisine';
import FastFoodCategoryType from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/MenuSetup/SelectMenu/FastFoodCategoryType';
import { FastFoodCrossSelling } from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/MenuSetup/FastFoodCrossSelling';
import { FastFoodSelectedCategories } from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/MenuSetup/SelectMenu/FastFoodSelectedCategories';
import { FastFoodEditCategories } from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/MenuSetup/SelectMenu/FastFoodEditCategories';
import FastFoodSelectItems from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/MenuSetup/SelectMenu/FastFoodSelectItems';
import { FastFoodSelectedItems } from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/MenuSetup/SelectMenu/FastFoodSelectedItems';
import { FastFoodUploadMenu } from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/MenuSetup/UploadMenu/FastFoodUploadMenu';
import FastFoodAddCategories from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/MenuSetup/FastFoodAddCategories';
import FastFoodAddItem from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/MenuSetup/AddItem/FastFoodAddItem';
import SubscriptionScreenDescription from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/SubscriptionScreenDescription';

import SettlementsVendor from '../../components/vendorDashboardComponents/SettlementsVendor/SettlementsVendor';
import SuperadminFAQManagement from '../../components/superAdminComponents/superAdminAllComponent/SuperadminFAQManagement/SuperadminFAQManagement';
import SuperAdminChatManagement from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminChatManagement/SuperAdminChatManagement';
import SuperAdminNotifyUsers from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminNotifyUsers/SuperAdminNotifyUsers';
import SuperAdminNotifyUsersCreate from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminNotifyUsers/SuperAdminNotifyUsersCreate';
import SuperAdminSMSTemplateManagement from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminSMSTemplateManagement/SuperAdminSMSTemplateManagement';
import SuperAdminEmailTemplateManagement from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminEmailTemplateManagement/SuperAdminEmailTemplateManagement';
import SuperAdminNonProfitOrg from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminNonProfitOrg/SuperAdminNonProfitOrg';
import SuperAdminAddNonProfitOrg from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminNonProfitOrg/SuperAdminAddNonProfitOrg';
import AddRsvpTicketBooked from '../../components/vendorDashboardComponents/events/OfflineEventDetails/AddRsvpEvent/AddRsvpTicketBooked';
import SuperAdminChainAddCategory from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminGlobalCatalogue/SuperAdminChainCatalogue/SuperAdminChainAddCategory';
import CasualDiningEditScanAndPayScreen from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/ScanAndPayManagement/CasualDiningEditScanAndPayScreen';
import FastFoodEditScanAndPayScreen from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/FastFoodManagementScreen/ScanAndPayManagement/FastFoodEditScanAndPayScreen';
import CasualDiningEditEventManagement from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/EventsManagement/CasualDiningEventManagementScreen';
import OfflineEventsEditSubscription from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/EventsManagement/OfflineEvents';
import OnlineEventsEditSubscription from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/EventsManagement/OnlineEvents';
import EditTicketBookingPayment from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/EventsManagement/TicketBookingPayment';
import EditFastFoodLiveStreaming from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/FastFoodManagementScreen/FastFoodLiveStreamingManagement/FastFoodLiveStreamingScreen';
import EditCasualLiveStreaming from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/CasualDiningLiveStreamingManagement/CasualDiningLiveStreamingScreen';
import EditWalkinWaitlistScreen from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/SeatingManagement/WalkinWaitlistScreen';
import EditReservationSubscription from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/SeatingManagement/ReservationSeatingScreen';
import EditGenralSettingsScreen from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/SeatingManagement/GenralSeatingScreen';
import EditCasualDiningSeatingManagement from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/SeatingManagement/CasualDiningSeatingManagementScreen';
import EditMainTableManagementScreen from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/SeatingManagement/TableManagementScreen';
import EditTableSeatManagement from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/SeatingManagement/TableSeatManagement';
import EditCasualDiningOrdering from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/OrderingManagement/CasualDiningOrderingScreen';
import EditCasualTakeaway from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/Takeaway';
import EditCasualCurbside from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/Curbside';
import EditCasualDinein from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/Dinein';
import EditCasualDineinTableManagement from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/DineinTableManagementScreen';
import EditCasualDineinTableSeatManagement from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/DineinTableSeatManagement';
import EditCasualCateringBanquet from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/CateringBanquet';
import EditCasualCateringRoomManagementScreen from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/CateringRoomManagementScreen';
import EditCasualCateringRoomSeatManagement from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/CateringRoomSeatManagement';
import EditCasualHomeDelivery from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/HomeDelivery';
import EditCasualBankAccount from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/BankAccount';
import EditCasualSeparateBankAccount from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/SeparateBankAccount';
import EditCasualGeneralSettingsTaxes from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/GeneralSettingsTaxes';

/*********************************
 * @DESC EDIT FAST FOOD ORDERING
 ********************************/
import EditFastFoodOrdering from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/FastFoodManagementScreen/OrderingManagement/FastFoodOrderingScreen';
import EditFastFoodTakeaway from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodTakeaway';
import EditFastFoodCurbside from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodCurbside';
import EditFastFoodBankAccount from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodBankAccount';
import EditFastFoodSeparateBankAccount from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodSeparateBankAccount';
import EditFastFoodGeneralSettingsTaxes from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodGeneralSettingsTaxes';
import EditFastFoodDinein from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodDinein';
import EditFastFoodSkiptheLine from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodSkipLine';
import EditFastFoodAtMySeatTableOrder from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodMySeatTableOrder';
import EditFastFoodCateringBanquet from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodCateringBanquet';
import EditFastFoodCateringRoomManagementScreen from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodCateringRoom';
import EditFastFoodCateringRoomSeatManagement from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodCateringRoomSeatManagement';
import SuperAdminRoleManagement from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminRoleManagement/SuperAdminRoleManagement';
import SuperAdminAddRole from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminRoleManagement/SuperAdminAddRole';
import StaffManagement from '../../components/vendorDashboardComponents/StaffManagement/StaffManagement';
import AddStaff from '../../components/vendorDashboardComponents/StaffManagement/AddStaff';
import EditStaff from '../../components/vendorDashboardComponents/StaffManagement/EditStaff';
import MenuSetUpDashboard from '../../components/vendorDashboardComponents/ItemAvailability/MenuSetUpDashboard';
import PaymentActivityReports from '../../components/vendorDashboardComponents/PaymentActivityReports/PaymentActivityReports';
import DisputeManagement from '../../components/vendorDashboardComponents/DisputeManagement/DisputeManagement';
import Memoslist from '../../components/vendorDashboardComponents/MemosDashboard/Memoslist';
import AddMemo from '../../components/vendorDashboardComponents/MemosDashboard/AddMemo';
import ViewMemo from '../../components/vendorDashboardComponents/MemosDashboard/ViewMemo';
import SuperAdminItemsforSettlement from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminItemsforSettlement/SuperAdminItemsforSettlement';
import SuperadminPayoutDetails from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminItemsforSettlement/SuperadminPayoutDetails';

/*****************************
 * @DESC Subscription routes
 ****************************/
import AdminScreenDescription from '../../components/superAdminComponents/subscriptionScreen/AdminScreenDescription';
import AdminViewSubscription from '../../components/superAdminComponents/subscriptionScreen/AdminViewSubscription';
import AdminCasualDiningOffers from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OffersManagement/AdminCasualDiningOffers';
import AdminCasualDiningScanAndPay from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/ScanAndPayManagement/AdminCasualDiningScanAndPay';
import AdminCasualDiningEventManagement from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/EventsManagement/AdminCasualDiningEventManagement';
import AdminCasualDiningExperienceManagement from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/ExperienceManagement/AdminCasualDiningExperienceManagement';
import AdminOfflineEventsSubscription from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/EventsManagement/OfflineEvents';
import AdminOnlineEventsSubscription from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/EventsManagement/OnlineEvents';
import AdminOfflineExperienceSubscription from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/ExperienceManagement/OfflineExperience';
import AdminTicketBookingPayment from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/EventsManagement/TicketBookingPayment';
import AdminTicketExpBookingPayment from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/ExperienceManagement/TicketExpBookingPayment.js';
import AdminCasualDiningLiveStreaming from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/CasualDiningLiveStreamingManagement/CasualDiningLiveStreamingScreen';
import AdminCasualDiningSeatingManagement from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/SeatingManagement/CasualDiningSeatingManagementScreen';
import AdminGenralSeating from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/SeatingManagement/GenralSeatingScreen';
import AdminWalkinWaitlist from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/SeatingManagement/WalkinWaitlistScreen';
import AdminReservationSeating from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/SeatingManagement/ReservationSeatingScreen';
import AdminTableManagement from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/SeatingManagement/TableManagementScreen';
import AdminTableSeatManagement from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/SeatingManagement/TableSeatManagement';

import AdminCasualDiningOrdering from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/CasualDiningOrderingScreen';
import AdminTakeaway from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/Takeaway';
import AdminCurbside from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/Curbside';
import AdminDinein from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/Dinein';
import AdminDineinTableManagement from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/DineinTableManagementScreen';
import AdminDineinTableSeatManagement from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/DineinTableSeatManagement';
import AdminCateringBanquet from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/CateringBanquet';
import AdminCateringRoomManagement from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/CateringRoomManagementScreen';
import AdminCateringRoomSeatManagement from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/CateringRoomSeatManagement';
import AdminHomeDelivery from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/HomeDelivery';
import AdminBankAccount from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/BankAccount';
import AdminSeparateBankAccount from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/SeparateBankAccount';
import AdminGeneralSettingsTaxes from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/GeneralSettingsTaxes';

import AdminMenuSetup from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/MenuSetup';
import AdminCuisine from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/SelectMenu/Cuisine';
import AdminCategoryType from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/SelectMenu/CategoryType';
import AdminCrossSelling from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/CrossSelling';
import AdminSelectedCategories from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/SelectMenu/SelectedCategories';
import AdminSelectedItemsNew from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/SelectMenu/SelectedItemsNew';
import { AdminEditCategories } from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/SelectMenu/EditCategories';
import AdminSelectItems from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/SelectMenu/SelectItems';
import AdminSelectItemsNew from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/SelectMenu/SelectItemNew';
import { AdminSelectedItems } from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/SelectMenu/SelectedItems';
import { AdminUploadMenu } from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/UploadMenu/UploadMenu';
import AdminAddCategories from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/AddCategories';
import AdminAddItem from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/AddItem/AddItem';

import SuperAdminOrderRefundAndCancellation from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminOrderRefundAndCancellation/SuperAdminOrderRefundAndCancellation';
import SelectedCategoriesVendor from '../../components/vendorDashboardComponents/ItemAvailability/SelectedCategoriesVendor';
import SelectItemsNewVendor from '../../components/vendorDashboardComponents/ItemAvailability/SelectItemsNewVendor';
import SelectedItemsVendor from '../../components/vendorDashboardComponents/ItemAvailability/SelectedItemsVendor';
import SelectedItemsNewVendor from '../../components/vendorDashboardComponents/ItemAvailability/SelectedItemsNewVendor';
import CrossSellingVendorDash from '../../components/vendorDashboardComponents/ItemAvailability/CrossSellingVendorDash';
import ChatVendorDashboard from '../../components/vendorDashboardComponents/ChatDashboard/ChatVendorDashboard';
import SuperAdminInvoices from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminInvoices/SuperAdminInvoices';
import SuperAdminOrderTaxSummaryReports from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminOrderTaxSummaryReports/SuperAdminOrderTaxSummaryReports';
import SuperAdminOrderItemSalesTaxReport from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminOrderTaxSummaryReports/SuperAdminOrderItemSalesTaxReport';
import SuperAdminSeatingActivityReport from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminSeatingVendor/SuperAdminSeatingActivityReport';
import SuperAdminSeatingPendingActivityReport from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminSeatingVendor/SuperAdminSeatingPendingActivityReport';
import SuperAdminSeatingAll from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminSeatingVendor/SuperAdminSeatingAll';
import VendorSeatingSummaryReports from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminSeatingVendor/VendorSeatingSummaryReports';
import SuperAdminOrderSummaryReport from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/orderingReports/SuperAdminOrderSummaryReport';
import SuperAdminOrderVendorReport from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/orderingReports/SuperAdminOrderVendorReport';
import SuperAdminPendingOrderActivityReports from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports';
import SuperAdminOrderTaxVendorReport from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminOrderTaxSummaryReports/SuperAdminOrderTaxVendorReport';
import SuperAdminOrderItemSalesTaxVendorReport from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminOrderTaxSummaryReports/SuperAdminOrderItemSalesTaxVendorReport';
import SuperAdminOrderItemSalesTaxSummaryReports from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminOrderTaxSummaryReports/SuperAdminOrderItemSalesTaxSummaryReports';
import SuperAdminOrderRefundCancellationSummaryReports from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminOrderRefundAndCancellation/SuperAdminOrderRefundCancellationSummaryReports';
import SuperAdminOrderRefundCancellationVendorReport from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminOrderRefundAndCancellation/SuperAdminOrderRefundCancellationVendorReport';
import SuperAdminSettlementSummaryReport from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminSettlements/SuperAdminSettlementSummaryReport';
import SuperAdminOrderSettlementReport from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminSettlements/SuperAdminOrderSettlementReport';
import SuperAdminAddSmsTemplate from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminSMSTemplateManagement/SuperAdminAddSmsTemplate';
import SuperAdminNotificationTemplate from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminNotificationTemplate/SuperAdminNotificationTemplate';
import SuperAdminEvnetsOnline from '../../components/superAdminComponents/superAdminAllComponent/superAdminRestaurantEvents/SuperAdminEvnetsOnline';
import OfflineEventDetailsScreen from '../../components/superAdminComponents/superAdminAllComponent/superAdminRestaurantEvents/OfflineEventDetails/OfflineEventDetails';
import SuperAdminOfflineEventsPending from '../../components/superAdminComponents/superAdminAllComponent/superAdminRestaurantEvents/OfflineEventDetails/SuperAdminOfflineEventsPending';
import SuperAdminOfflineEventsBooked from '../../components/superAdminComponents/superAdminAllComponent/superAdminRestaurantEvents/OfflineEventDetails/SuperAdminOfflineEventsBooked';
import SuperAdminOfflineEventsHistory from '../../components/superAdminComponents/superAdminAllComponent/superAdminRestaurantEvents/OfflineEventDetails/SuperAdminOfflineEventsHistory';
import SuperAdminOfflineEventAll from '../../components/superAdminComponents/superAdminAllComponent/superAdminRestaurantEvents/OfflineEventDetails/SuperAdminOfflineEventAll';
import SuperAdminEditTemplate from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminSMSTemplateManagement/SuperAdminEditTemplate';
import VendorOrderTaxReport from '../../components/vendorDashboardComponents/OrderReports/VendorOrderTaxReport';
import VendorOrderRefundCancellationReport from '../../components/vendorDashboardComponents/OrderReports/VendorOrderRefundCancellationReport';
import SuperAdminInvoice from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminInvoice/SuperAdminInovice';
import SuperAdminMainSeatingDashboard from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminSeatingVendor/SuperAdminSeatingDashboard/SuperAdminMainSeatingDashboard';
import SuperAdminMainReservation from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminSeatingVendor/SuperAdminSeatingDashboard/SuperAdminMainReservation';
import SuperAdminSeatingMainHistoryDashboard from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminSeatingVendor/SuperAdminSeatingDashboard/SuperAdminSeatingMainHistoryDashboard';
import SuperAdminMainPendingDashboard from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminSeatingVendor/SuperAdminSeatingDashboard/SuperAdminMainPendingDashboard';
import AdminAddDinerReservation from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminSeatingVendor/SuperAdminSeatingDashboard/AddAndEditDiner/AdminAddDinerReservation';
import MemoPayment from '../../components/vendorDashboardComponents/MemosDashboard/MemoPayment';
import AddDinerReservationScreen from '../../components/vendorDashboardComponents/seatingDashboard/AddDinerScreen/AddDinerReservationScreen';
import SuperadminPayoutHistory from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminItemsforSettlement/SuperadminPayoutHistory';
import SuperAdminUserWallatTransactionsMain from '../../components/superAdminComponents/superAdminAllComponent/superAdminUserWallatTransactions/SuperAdminUserWallatTransactionsMain';
import SuperAdminPaymentActivityReports from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminPaymentActivityReports/SuperAdminPaymentActivityReports';
import CurationPage from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminExperience/Curationdashboard/Curationpage';
import PageSections from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminExperience/Curationdashboard/PageSections';
import AddExpToTopSection from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminExperience/Curationdashboard/AddExpToTopSection';
import AddExp from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminExperience/AddingPagesSections/AddExp';
import AddSection from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminExperience/AddingPagesSections/AddSection';
import OfferVendorrRports from '../../components/vendorDashboardComponents/Reports/OfferVendorrRports';
import Addpages from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminExperience/AddingPagesSections/Addpages';
import EventReports from '../../components/vendorDashboardComponents/events/EventReports';
import AllSeatingReport from '../../components/vendorDashboardComponents/Reports/AllSeatingReports';
import PendingSeatingOrder from '../../components/vendorDashboardComponents/Reports/PendingSeatingOrder';
import AllOrderReport from '../../components/vendorDashboardComponents/Reports/AllOrderReport';
import PendingOrderReport from '../../components/vendorDashboardComponents/Reports/PendingOrderReport';
import ScanAndPayReport from '../../components/vendorDashboardComponents/Reports/ScanAndPayReport';
import ReferalReport from '../../components/vendorDashboardComponents/Reports/ReferalReport';
import InvoiceReport from '../../components/vendorDashboardComponents/Reports/InvoiceReport';
import OrderItemSalesAndTaxReport from '../../components/vendorDashboardComponents/Reports/OrderItemSalesAndTaxReport';
import MainSettlementsVendor from '../../components/vendorDashboardComponents/SettlementsVendor/MainSettlementsVendor';
import SuperAdminAllOrders from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminOrders/SuperAdminAllOrders';
import SuperAdminPendingOrders from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminOrders/SuperAdminPendingOrders';
import SuperAdminPaymentActivitySummaryReportss from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminPaymentActivityReports/SuperAdminPaymentActivitySummaryReportss';
import EventSummaryReport from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/EventSummaryReport';
import OffersActivity from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/OffersActivity';
import AllSeatingActivityReports from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/AllSeatingActivityReports';
import Earnings from '../../components/vendorDashboardComponents/Earnings/Earnings';
import CreatecuratedExp from '../../components/vendorDashboardComponents/Experiences/CreateExperiences/CreateExpericence';
import MainExperienceDashboard from '../../components/vendorDashboardComponents/Experiences/Experiencedashboard/MainExperienceDashboard';
import PayoutHistory from '../../components/vendorDashboardComponents/Earnings/PayoutHistory';
import OfferSummaryReport from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/OfferSummaryReport';
import OfferVendorReport from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/OfferVendorReport';
import EventVendorReport from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/EventVendorReport';
import SeatingPendingActivityReport from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/SeatingPendingActivityReports';
import SeatingSummaryReport from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/SeatingSummaryReport';
import SeatingVendorReports from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/SeatingVendorReports';
import ItemReport from '../../components/vendorDashboardComponents/Reports/ItemReport';
import SeatingAnalytics from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/SeatingAnalytics';
import SettlementEventsReport from '../../components/vendorDashboardComponents/SettlementsVendor/SettlementEventsReport';
import SettlementScanAndPayReport from '../../components/vendorDashboardComponents/SettlementsVendor/SettlementScanAndPayReport';
import SuperAdminSettlementSummaryReportsVendor from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/SuperAdminSettlementReports/SuperAdminSettlementSummaryReportsVendor';
import ScanAndPayActivityReport from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/ScanAndPayActivityReport/ScanAndPayActivityReport';
import ScanAndPaySummaryReport from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/ScanAndPayActivityReport/ScanAndPaySummaryReport';
import ScanAndPayVendorReport from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/ScanAndPayActivityReport/ScanAndPayVendorReport';
import AllOrderActivityReports from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/orderingReports/AllOrderActivityReports';
import PendingOrderActivityReports from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/orderingReports/PendingOrderActivityReports';
import SuperAdminOrderTaxActivityReports from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminOrderRefundAndCancellation/SuperAdminOrderTaxActivityReports';
import SuperAdminOrderRefundCancellationActivityReports from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminOrderRefundAndCancellation/SuperAdminOrderRefundCancellationActivityReports';
import SuperAdminMainReportsDashboard from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminChartReports/reportsDashboard/SuperAdminMainReportsDashboard';
import SuperAdminUserWallet from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminUserWallet/SuperAdminUserWallet';
import MenuItemSummaryReport from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/MenuItemSummaryReport';
import VendorItemReport from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/VendorItemReport';
import MenuItemActivityReport from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/MenuItemActivityReport';
import SuperAdminUserWalletDashboard from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminUserWallet/SuperAdminUserWalletDashboard';
import SuperAdminUserWalletAllReferrals from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminUserWallet/SuperAdminUserWalletAllReferrals';
import SuperAdminUserWalletTransferMoneyRequest from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminUserWallet/SuperAdminUserWalletTransferMoneyRequest';
import SuperAdminUserTransferMoneyProcess from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminUserWallet/SuperAdminUserTransferMoneyProcess';
import SuperAdminUserWalletAddRemoveMoneyRequest from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminUserWallet/SuperAdminUserWalletAddRemoveMoneyRequest';
import SuperAdminUserProcess from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminUserWallet/SuperAdminUserProcess';
import SuperAdminDepartmentalWallet from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminDepartmentalWallet/SuperAdminDepartmentalWallet';
import SuperAdminDepartmentalWalletAdd from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminDepartmentalWallet/SuperAdminDepartmentalWalletAdd';
import SuperAdminDepartmentalWalletAddRemoveMoneyRequest from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminDepartmentalWallet/SuperAdminDepartmentalWalletAddRemoveMoneyRequest';
import SuperAdminDepartmentalProcess from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminDepartmentalWallet/SuperAdminDepartmentalProcess';
import SuperAdminErrorLogs from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminErrorLogs/SuperAdminErrorLogs';
import UserRegistrationAmealio from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/UserRegistrationAmealio';
import Offerviewed from '../../components/vendorDashboardComponents/Reports/OfferUsed';
import OfferUsed from '../../components/vendorDashboardComponents/Reports/OfferUsed';
import SuperAdminOfferUsed from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/SuperAdminOfferUsed';
import Repayment from '../../components/vendorDashboardComponents/Orders/OrderRequest/Repayment';
import CategoryReport from '../../components/vendorDashboardComponents/Reports/CategoryReport';
import SuperAdminPaymentSummaryReoportsVendor from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminPaymentActivityReports/SuperAdminPaymentSummaryReoportsVendor/SuperAdminPaymentSummaryReoportsVendor';
import AdminLogin from '../../components/authentication/login/AdminLogin';
import AllMerchantStatement from '../../components/superAdminComponents/superAdminAllComponent/AllMerchantStatement/AllMerchantStatement';
import MerchantStatementDetail from '../../components/superAdminComponents/superAdminAllComponent/AllMerchantStatement/AdminMerchantStatementDetail';
import MerchantStatement from '../../components/vendorDashboardComponents/Reports/MerchantStatementDetail';
import SingleMerchantStatement from '../../components/vendorDashboardComponents/Reports/SingleMerchantstatement';
import SuperAdminRequestCheckout from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminItemsforSettlement/SuperAdminRequestCheckout';
import SuperAdminInitiatedSettlement from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminItemsforSettlement/SuperAdminInitiatedSettlement';
import FastFoodMySeatTable from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodMySeatTable';
import EditFastFoodHomeDelivery from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/FastFoodManagementScreen/OrderingManagement/SubPages/FastFoodHomeDelivery';
import SuperAdminViewPayoutDetails from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminItemsforSettlement/SuperAdminViewPayoutDetails';
import EditAtMySeatTableOrder from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/EditAtMySeatTableOrder';
import EditSkipLine from '../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/OrderingManagement/SubPages/EditSkipLine';
import OfflineEventTableManagementScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/EventsManagement/OfflineEventTableManagementScreen';
import OfflineEventTableSeatManagement from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/EventsManagement/OfflineEventTableSeatManagement';
import SelectedItemFromCategory from '../../components/vendorDashboardComponents/ItemAvailability/AddItemFromCateloge/SelectedItemFromCategory';
import SuperAdminPromotionalVideos from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminPromotionalVideos/SuperAdminPromotionalVideos';
import AdminAddNewVideo from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminPromotionalVideos/AddVideo/AdminAddNewVideo';
import SuperAdminShortVideoDashboard from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminShortVideos/ShortVideoDashboard/SuperAdminShortVideoDashboard';
import AdminAddShortVideo from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminShortVideos/AddShortVideos/AdminAddShortVideo';
import SuperadminPayoutViewDetails from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminItemsforSettlement/SuperadminPayoutViewDetails';
import SelectedItemsFromCatelogueCategory from '../../components/vendorDashboardComponents/ItemAvailability/AddItemFromCateloge/SelectedItemsFromCatelogueCategory';
import EventQrCodePublicDisplay from '../../components/reusableComponents/EventQrCodePublicDisplay/EventQrCodePublicDisplay';
import SuperAdminProcessedSettlement from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminItemsforSettlement/SuperAdminProcessedSettlement';
import OnboardSelectedItemFromCategory from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/OnboardSelectedItemFromCategory';
import OnboardSelectedItemFromCatelogueCategory from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/OnboardSelectedItemFromCatelogueCategory';
import SuperAdminAddUom from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminUOMServices/superAdminAddUom';
import SuperAdminAddUomRatio from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminUOMServices/superAdminAddUomRatio';
import SuperAdminDisplayUom from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminUOMServices/superAdminDisplayUom';
import SuperAdminDisplayUomRatio from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminUOMServices/superAdminDisplayUomRatio';
import SuperAdminMerchantPromotion from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminMerchantPromotion/SuperAdminMerchantPromotion';
import SuperAdminMaintainMerchantTags from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminMerchantTags/SuperAdminMaintainMerchantTags';
import SuperAdminValidateMerchantTags from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminMerchantTags/SuperAdminValidateMerchantTags';
import SuperAdminApproveMerchantTags from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminMerchantTags/SuperAdminApproveMerchantTags';
import SuperAdminVendorReportsStauts from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/SuperAdminVendorReportsStauts/SuperAdminVendorReportsStauts';
import EditAdminOnlineOffer from '../../components/superAdminComponents/superAdminAllComponent/superAdminOffers/EditOffer/EditAdminOnlineOffer';
import EditOrderRequestMerchant from '../../components/vendorDashboardComponents/Orders/EditOrder/EditOrderRequestMerchant';
import UserCloseWalletRequests from '../../components/superAdminComponents/superAdminAllComponent/UserCloseWallat/UserCloseWalletRequests';
import DeleteUsersList from '../../components/superAdminComponents/superAdminAllComponent/superAdminUsers/DeleteUsers/DeleteUsers.js';
import MainCuratedDashboard from '../../components/vendorDashboardComponents/Experiences/Experiencedashboard/MainCuratedDashboard';
import MainSpecialDashboard from '../../components/vendorDashboardComponents/Experiences/Experiencedashboard/MainSpeciaDashboard';
import ExpiredExperiencesdashboard from '../../components/vendorDashboardComponents/Experiences/Experiencedashboard/ExpiredExperiencesdashboard';
import CreateExperience from '../../components/vendorDashboardComponents/Experiences/CreateExperiences/CreateExpericence';
import EditExperience from '../../components/vendorDashboardComponents/Experiences/CreateExperiences/EditExpericence';
import SpecialDashboardDetails from '../../components/vendorDashboardComponents/Experiences/Experiencedashboard/SpecialDashboardDetails';
import AddExperienceGuest from '../../components/vendorDashboardComponents/Experiences/Experiencedashboard/AddGuests/AddGuest';
import ExperienceManagementScreen from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/ExperienceManagement/ExperienceManagementScreen';
import AdminExperienceManagementScreen from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/ExperienceManagement/AdminExperienceManagementScreen';
import OfflineExperienceManagement from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/ExperienceManagement/OfflineExperienceManagement';
import SpecialOfflineExperienceManagement from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/ExperienceManagement/SpecialOfflineExperienceManagement';
import CuratedOfflineExperienceManagement from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/ExperienceManagement/CuratedOfflineExperienceManagement';
import MerchantDashboardAndOnboardingRoute from './MerchantDashboardAndOnboardingRoute';
import SuperAdminSeatingPendingExperienceReport from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminExperience/PendingExperienceDashboard/SuperAdminSeatingPendingExperienceReport';
import CuratedDashboardDetails from '../../components/vendorDashboardComponents/Experiences/Experiencedashboard/CuratedDashboardDetails';
import SuperAdminSeatingActivityExperienceReport from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminExperience/ActivityExperienceDashboard/SuperAdminSeatingActivityExperienceReport';
import AllExperienceDashboard from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminExperience/AllExperienceDashboard/AllExperienceDashboard';
import MerchantExperienceManagementDashboard from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminExperience/MerchantExperienceManagementDashboard/MerchantExperienceManagementDashboard';
import MainExpHistoryDashboard from '../../components/vendorDashboardComponents/Experiences/Experiencedashboard/MainExpHistoryDashboard';
import EditExperienceGuest from '../../components/vendorDashboardComponents/Experiences/Experiencedashboard/AddGuests/EditGuest';
import DunzoStatementRestaurants from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminDunzo/DunzoStatementRestaurants';
import ExpSummaryReport from '../../components/vendorDashboardComponents/Experiences/Reports/ExpSummaryReport';
import ExpVendorReport from '../../components/vendorDashboardComponents/Experiences/Reports/ExpVendorReport';
import ExpActivityReport from '../../components/vendorDashboardComponents/Experiences/Reports/ExpActivityReport';
import ExpCancellationReport from '../../components/vendorDashboardComponents/Experiences/Reports/ExpCancellatonReport';
import VendorExpReport from '../../components/vendorDashboardComponents/Experiences/Reports/VendorExpReport';
import VendorExpDetailReport from '../../components/vendorDashboardComponents/Experiences/Reports/VendorExpDetailReport';
import SettlementsExpVendor from '../../components/vendorDashboardComponents/SettlementsVendor/SettlementsExpVendor';
import ExpRefundReport from '../../components/vendorDashboardComponents/Experiences/Reports/ExpRefundReport';
import SuperAdminResetClearSettlement from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminItemsforSettlement/SuperAdminResetClearSettlement';
import SuperAdminResetUnclearSettlement from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminItemsforSettlement/SuperAdminResetUnclearSettlement';
import RetainedUsersList from '../../components/superAdminComponents/superAdminAllComponent/superAdminUsers/DeleteUsers/RetainedUsers';
import SuperAdminDunzoTransactions from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminOrderTaxSummaryReports/SuperAdminDunzoTransactions';
import SuperAdminDeliveryCancelledOrderReport from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminOrderTaxSummaryReports/SuperAdminDeliveryCancelledOrderReport';
import SuperAdminDeliveryOrderReport from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminOrderTaxSummaryReports/SuperAdminDeliveryOrderReport';
import CancelledOrders from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminItemsforSettlement/CancelledOrders';
import EditExperienceTaxes from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/ExperienceManagement/EditExperienceTaxes';
import AdminEditExperienceTaxes from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/ExperienceManagement/AdminEditExperienceTaxes.js';
import MainExpAllDashboard from '../../components/vendorDashboardComponents/Experiences/Experiencedashboard/MainExpAllDashboard';
import MainExpSpecialDashboard from '../../components/vendorDashboardComponents/Experiences/Experiencedashboard/MainExpSpecialDashboard';
import MainExpCuratedDashboard from '../../components/vendorDashboardComponents/Experiences/Experiencedashboard/MainExpCuratedDashboard';
import ExperienceQrCodePublicDisplay from '../../components/reusableComponents/EventQrCodePublicDisplay/ExperienceQrCodePublicDisplay';
import PosLoginReport from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminPosSettings/PosLoginReport';
import PosPriceUpdateReport from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminPosSettings/PosPriceUpdateReport';
import AddPos from '../../components/superAdminComponents/superAdminAllComponent/SuperAdminPosSettings/AddPos/AddPos';
import PosWithId from '../../components/vendorOnboradingComponents/allScreens/PosId/PosWithId';
import RestaurantAnalytics from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/userAnalytics/RestaurantAnalytics';
import AmealiogeneralAnalytics from '../../components/superAdminComponents/superAdminAllComponent/superAdminReports/userAnalytics/AmealiogeneralAnalytics';
import AdminCuratedOfflineExperienceManagament from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/ExperienceManagement/AdminCuratedOfflineExperienceManagament';
import AdminSpecialOfflineExperienceManagement from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/ExperienceManagement/AdminSpecialOfflineExperienceManagement.js';
import AdminOfflineExperienceManagement from '../../components/superAdminComponents/subscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/ExperienceManagement/AdminOfflineExperienceManagement.js';
import CreateCustomMenu from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/CustomMenu/CreateCustomMenu.js';
import vendorDashboardCreateMenu from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/CustomMenu/VendorDashboardCreateMenu.js';
import CreateCustomMenuOnboard from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/CustomMenu/CreateCustomMenuOnboard.js';
import AddItemFromMenu from '../../components/vendorDashboardComponents/ItemAvailability/AddItemFromMenu.js';
import CreateCombos from '../../components/vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/combos/CreateCombos.js';
// import TestMap from "../../components/vendorDashboardComponents/UserTracking/TestMap";
// import EditCasualDiningEventManagementScreen from "../../components/vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionEditScreen/InsidePageScreen/CasualDiningManagementScreen/EventsManagement/EditCasualDiningEventManagementScreen";
//added routes
const Routes = () => {
  return (
    <>
      <Fragment>
        <Switch>
          <PrivateRoute exact path="/editprofile" component={EditProfile} />
          <PrivateRoute exact path="/profile" component={VendorProfile} />
          <PrivateRoute
            exact
            path="/customerbusiness"
            component={CustomersBusiness}
          />
          <PrivateRoute
            exact
            path="/livestreamingsession"
            component={LiveStreamingSession}
          />
          {/* <PrivateRoute
              exact
              path="/notification" 
              component={NotificationComponent}
            /> */}
          <PrivateRoute exact path="/notification" component={Notification} />
          <PrivateRoute exact path="/displaypopup" component={DisplayPage} />
          <PrivateRoute
            exact
            path="/reportdashboard"
            component={MainReportsDashboard}
          />
          <PrivateRoute
            exact
            path="/seatingdashboard"
            component={MainSeatingDashboard}
          />
          {/* T-dev done */}
          <PrivateRoute
            exact
            path="/offervendorreports"
            component={OfferVendorrRports}
          />
          <PrivateRoute exact path="/eventreports" component={EventReports} />
          <PrivateRoute
            exact
            path="/allseatingreports"
            component={AllSeatingReport}
          />
          <PrivateRoute
            exact
            path="/pendingseatingorder"
            component={PendingSeatingOrder}
          />
          <PrivateRoute
            exact
            path="/allorderreport"
            component={AllOrderReport}
          />
          <PrivateRoute
            exact
            path="/pendingorderreport"
            component={PendingOrderReport}
          />
          <PrivateRoute
            exact
            path="/scanandpayreport"
            component={ScanAndPayReport}
          />
          <PrivateRoute exact path="/referalreport" component={ReferalReport} />
          <PrivateRoute
            exact
            path="/experiencereport"
            component={VendorExpReport}
          />
          <PrivateRoute
            exact
            path="/experiencereport/:id"
            component={VendorExpDetailReport}
          />
          <PrivateRoute exact path="/invoicereport" component={InvoiceReport} />
          <PrivateRoute
            exact
            path="/orderitem-sale-and-taxreport"
            component={OrderItemSalesAndTaxReport}
          />
          <PrivateRoute exact path="/itemreports" component={ItemReport} />
          <PrivateRoute
            exact
            path="/categoryreports"
            component={CategoryReport}
          />
          <PrivateRoute
            exact
            path="/mainsettlementsvendor"
            component={MainSettlementsVendor}
          />
          <PrivateRoute
            exact
            path="/merchantStatement"
            component={MerchantStatement}
          />
          <PrivateRoute
            exact
            path="/singleMerchantStatement"
            component={SingleMerchantStatement}
          />
          <PrivateRoute
            exact
            path="/settlementeventsvendor/:type/:id/:restaurant_id"
            component={SettlementEventsReport}
          />
          <PrivateRoute
            exact
            path="/settlementscanandpayvendor/:type/:id/:restaurant_id"
            component={SettlementScanAndPayReport}
          />
          <PrivateRoute
            exact
            path="/settlementexpvendor/:type/:id/:restaurant_id"
            component={SettlementsExpVendor}
          />
          {/* t-dev */}
          <PrivateRoute
            exact
            path="/seatingdashboard/adddiner"
            component={AddDinerReservationScreen}
          />
          <PrivateRoute
            exact
            path="/seatingdashboard/editdiner/:id"
            component={AddDinerReservationScreen}
          />
          <PrivateRoute
            exact
            path="/pendingdashboard"
            component={MainPendingDashboard}
          />
          <PrivateRoute
            exact
            path="/reservationdashboard"
            component={MainReservation}
          />
          <PrivateRoute
            exact
            path="/historydashboard"
            component={MainHistoryDashboard}
          />
          <PrivateRoute exact path="/offer" component={Offer} />
          <PrivateRoute
            exact
            path="/offer/add-offer"
            component={AddOfferNewVendor}
          />
          <PrivateRoute
            exact
            path="/offer/edit-offline-offer/:offerId"
            component={VendorEditOfflineOffer}
          />
          <PrivateRoute exact path="/offerused" component={OfferUsed} />
          <PrivateRoute
            exact
            path="/offer/edit-online-offer/:offerId"
            component={VendorEditOnlineOffer}
          />
          <PrivateRoute exact path="/event" component={Event} />
          <PrivateRoute
            exact
            path="/createCurated"
            component={CreateExperience}
          />
          <PrivateRoute
            exact
            path="/editCurated/:id"
            component={EditExperience}
          />
          <PrivateRoute
            exact
            path="/createSpecial"
            component={CreateExperience}
          />
          <PrivateRoute
            exact
            path="/editSpecial/:id"
            component={EditExperience}
          />
          {/* <PrivateRoute exact path="/experienceDashboard/i" component={MainExperienceDashboard} /> */}
          <PrivateRoute
            exact
            path="/experienceDashboard/pending"
            component={MainExperienceDashboard}
          />
          <PrivateRoute
            exact
            path="/experienceDashboard/all"
            component={MainExpAllDashboard}
          />
          <PrivateRoute
            exact
            path="/experienceDashboard/special"
            component={MainExpSpecialDashboard}
          />
          <PrivateRoute
            exact
            path="/experienceDashboard/curated"
            component={MainExpCuratedDashboard}
          />
          <PrivateRoute
            exact
            path="/experienceDashboard/pending"
            component={MainExperienceDashboard}
          />
          <PrivateRoute
            exact
            path="/experienceDashboard/pending"
            component={MainExperienceDashboard}
          />
          <PrivateRoute
            exact
            path="/curatedDashboard"
            component={MainCuratedDashboard}
          />
          <PrivateRoute
            exact
            path="/specialDashboard"
            component={MainSpecialDashboard}
          />
          <PrivateRoute
            exact
            path="/expiredexperiencesDashboard"
            component={ExpiredExperiencesdashboard}
          />
          <PrivateRoute
            exact
            path="/experienceDashboard/history"
            component={MainExpHistoryDashboard}
          />
          <PrivateRoute
            exact
            path="/specialDashboard/:id/:page"
            component={SpecialDashboardDetails}
          />
          <PrivateRoute
            exact
            path="/special/addGuests/:id?"
            component={AddExperienceGuest}
          />
          <PrivateRoute
            exact
            path="/special/editGuests/:id"
            component={EditExperienceGuest}
          />
          <PrivateRoute
            exact
            path="/curatedDashboard/:id/:page"
            component={CuratedDashboardDetails}
          />
          <PrivateRoute
            exact
            path="/curated/addGuests/:id?"
            component={AddExperienceGuest}
          />
          <PrivateRoute
            exact
            path="/curated/editGuests/:id"
            component={EditExperienceGuest}
          />

          <PrivateRoute
            exact
            path="/event/add-event"
            component={AddNewEventVendor}
          />
          <PrivateRoute
            exact
            path="/event/edit-offline-event"
            component={VendorEditOfflineEvent}
          />
          <PrivateRoute
            exact
            path="/event/edit-online-event"
            component={VendorEditOnlineEvent}
          />
          <PrivateRoute
            exact
            path="/online-event-details/:id"
            component={OnlineEventDetails}
          />
          <PrivateRoute
            exact
            path="/vendorreviews"
            component={VendorRatingReviewsComponent}
          />
          <PrivateRoute
            exact
            path="/vendoruseropenissues"
            component={OpenIssuesVendor}
          />
          <PrivateRoute
            exact
            path="/viewticketvendoruseropenissue/:ticketId"
            component={VendorUserOpenIssuesView}
          />
          <PrivateRoute
            exact
            path="/vendoropensuggestionissues"
            component={VendorOpenIssuesMainSuggestion}
          />
          <PrivateRoute
            exact
            path="/disputemanagement"
            component={DisputeManagement}
          />
          {/*  */}
          <PrivateRoute
            exact
            path="/viewticketvendoropensuggestionissues/:issueId"
            component={VendorOpenIssuesSuggestionView}
          />
          <PrivateRoute
            exact
            path="/editticketvendoropensuggestionissues"
            component={VendorOpenIssuesSuggestionEdit}
          />
          <PrivateRoute
            exact
            path="/editvendoropenticketissue"
            component={VendorOpenIssuesTicketEdit}
          />
          <PrivateRoute exact path="/qrcodeprint" component={QRCodeView} />
          <PrivateRoute
            exact
            path="/Referralqrcodeprint"
            component={ReferralQrcodeView}
          />
          <PrivateRoute
            exact
            path="/reportdashboard/offers"
            component={OffersReportsDetails}
          />
          <PrivateRoute
            exact
            path="/reportdashboard/events/:id"
            component={EventsReportsDetails}
          />
          <PrivateRoute
            exact
            path="/orderrequest/:token?"
            component={OrderRequest}
          />
          <PrivateRoute
            exact
            path="/substituteitem"
            component={SubstituteItem}
          />
          <PrivateRoute
            exact
            path="/addnewedititems"
            component={EditPageAddNewItem}
          />
          <PrivateRoute exact path="/orderpayment" component={OrderPayment} />
          <PrivateRoute
            exact
            path="/additem-orderpayment"
            component={EditAddItemPayment}
          />
          <PrivateRoute
            exact
            path="/reorderpayment"
            component={ReOrderPayment}
          />
          <PrivateRoute
            exact
            path="/orderpaymentsubstitute"
            component={OrderPaymentSubstitute}
          />
          <PrivateRoute exact path="/ordertrack" component={OrderTrack} />
          <PrivateRoute
            exact
            path="/orderdashboard/:page?"
            component={OrderDashboard}
          />
          <PrivateRoute
            exact
            path="/orderdashboard/editorder-request/:id"
            component={EditOrderRequestMerchant}
          />
          <PrivateRoute exact path="/payment" component={Payment} />
          <PrivateRoute exact path="/repayment" component={Repayment} />
          <PrivateRoute exact path="/addorder" component={AddOrder} />
          <PrivateRoute
            exact
            path="/itemavailablitydashboard"
            component={ItemAvailability}
          />
          <PrivateRoute
            exact
            path="/additemavailablity"
            component={AddItemAvailability}
          />
          <PrivateRoute
            exact
            path="/additemavailablity/frommenu"
            component={AddItemFromMenu}
          />
          <PrivateRoute
            exact
            path="/additemavailablity/catalogverified"
            component={AddItemAvailability}
          />
          <PrivateRoute
            exact
            path="/categorydashboard"
            component={CategoryDashboard}
          />
          <PrivateRoute
            exact
            path="/offline-events-details/:id"
            component={OfflineEventDetails}
          />
          <PrivateRoute
            exact
            path="/offline-events-pending/:id"
            component={OfflineEventsPending}
          />
          <PrivateRoute
            exact
            path="/offline-events-booked/:id"
            component={OfflineEventsBooked}
          />
          <PrivateRoute
            exact
            path="/offline-events-history/:id"
            component={OfflineEventsHistory}
          />
          <PrivateRoute
            exact
            path="/offline-events-all/:id"
            component={OfflineEventAll}
          />
          <PrivateRoute
            exact
            path="/offline-events/add-event"
            component={AddEvent}
          />
          {/* <PrivateRoute exact path="/userTracking component={TestMap} /> */}
          <PrivateRoute
            exact
            path="/offline-events/add-guest-event/:id"
            component={AddRsvpTicketBooked}
          />
          <PrivateRoute
            exact
            path="/offline-events/edit-guest-event/:id"
            component={AddRsvpTicketBooked}
          />
          <PrivateRoute
            exact
            path="/manage-block-reservation-calendar"
            component={ManageBlockReservationCalender}
          />
          <PrivateRoute exact path="/block-date" component={BlockDateOrSlot} />
          <PrivateRoute
            exact
            path="/chat-dashboard"
            component={ChatVendorDashboard}
          />
          <PrivateRoute
            exact
            path="/all-reservations"
            component={AllReservations}
          />
          <PrivateRoute
            exact
            path="/addcategory"
            component={VendorDashboardAddcategory}
          />
          <PrivateRoute exact path="/createcombos" component={CreateCombos} />
          <PrivateRoute exact path="/editcombo/:id" component={CreateCombos} />
          <PrivateRoute
            exact
            path="/addcategory/verifiedVendor"
            component={VendorDashboardAddcategory}
          />
          <PrivateRoute
            exact
            path="/menusetup-dashboard"
            component={MenuSetUpDashboard}
          />
          <PrivateRoute
            exact
            path="/createcustommenu"
            component={vendorDashboardCreateMenu}
          />
          <PrivateRoute
            exact
            path="/paymentactivityreports"
            component={PaymentActivityReports}
          />
          <PrivateRoute
            exact
            path="/selectedcategories"
            component={SelectedCategoriesVendor}
          />
          <PrivateRoute
            exact
            path="/selecteditemsnew"
            component={SelectedItemsNewVendor}
          />
          <PrivateRoute
            exact
            path="/selectitemsnew"
            component={SelectItemsNewVendor}
          />
          <PrivateRoute
            exact
            path="/additem-from-catalogue"
            component={SelectedItemFromCategory}
          />
          <DetailsPrivateRoute
            exact
            path="/onboard-additem-from-catalogue"
            component={OnboardSelectedItemFromCategory}
          />
          <PrivateRoute
            exact
            path="/select-items-from-catalogue"
            component={SelectedItemsFromCatelogueCategory}
          />
          <DetailsPrivateRoute
            exact
            path="/onboard-select-items-from-catalogue"
            component={OnboardSelectedItemFromCatelogueCategory}
          />
          <PrivateRoute
            exact
            path="/selecteditems"
            component={SelectedItemsVendor}
          />
          <PrivateRoute
            exact
            path="/menusetup/crossselling"
            component={CrossSellingVendorDash}
          />
          <PrivateRoute
            exact
            path="/settlementsvendor/:type/:id/:restaurant_id"
            component={SettlementsVendor}
          />
          <PrivateRoute
            exact
            path="/ordertaxreport"
            component={VendorOrderTaxReport}
          />
          <PrivateRoute
            exact
            path="/orderrefundcancellationreport"
            component={VendorOrderRefundCancellationReport}
          />
          <PrivateRoute exact path="/earnings" component={Earnings} />
          <PrivateRoute
            exact
            path="/earnings/payouthistory/:sattlementId"
            component={PayoutHistory}
          />
          {/* /****************************************************************
              @DESC Vendor Dashboard Edit Link 
            *****************************************************************/}
          <PrivateRoute
            exact
            path="/editmapsetup"
            component={VendorMapSetupEdit}
          />
          <PrivateRoute
            exact
            path="/editrestaurantdetails"
            component={VendorRestaurantDetailsEdit}
          />
          <PrivateRoute
            exact
            path="/editrestaurantimage"
            component={VendorRestaurantDetailsLogoImage}
          />
          <PrivateRoute
            exact
            path="/editpointofcontacts"
            component={VendorPointOfContactsEdit}
          />
          <PrivateRoute
            exact
            path="/editrestaurantchains"
            component={VendorRestaurantChainEdit}
          />
          <PrivateRoute
            exact
            path="/editrestauranttype"
            component={VendorRestaurantTypeEdit}
          />
          <PrivateRoute
            exact
            path="/editpaymentmethod"
            component={VendorPaymentMethodEdit}
          />
          <PrivateRoute
            exact
            path="/editdresscode"
            component={VendorDressCodeEdit}
          />
          <PrivateRoute
            exact
            path="/editpetsallowed"
            component={VendorPetsAllowedEdit}
          />
          <PrivateRoute
            exact
            path="/editlocatedinside"
            component={VendorLocatedInsideEdit}
          />
          <PrivateRoute
            exact
            path="/edithealthandsenitation"
            component={VendorHealthAndSenitationEdit}
          />
          <PrivateRoute
            exact
            path="/edithealthandsenitationFacility"
            component={VendorHealthAndSenitationFacilityEdit}
          />
          <PrivateRoute
            exact
            path="/edithealthandsenitationemployees"
            component={VendorHealthAndSenitationEmployeesEdit}
          />
          <PrivateRoute
            exact
            path="/edithealthandsenitationfoodhandling"
            component={VendorHealthAndSenitationFoodHandlingEdit}
          />
          <PrivateRoute
            exact
            path="/edithealthandsenitationSafety"
            component={VendorHealthAndSenitationHealthSafetyEdit}
          />
          <PrivateRoute
            exact
            path="/edithealthandsenitationprotocol"
            component={VendorHealthAndSenitationProtocol}
          />
          <PrivateRoute
            exact
            path="/editparking"
            component={VendorParkingEdit}
          />
          <PrivateRoute
            exact
            path="/editaccessibility"
            component={VendorAccessibilityTypeEdit}
          />
          <PrivateRoute
            exact
            path="/editotherfeatures"
            component={VendorOtherFeaturesEdit}
          />
          <PrivateRoute
            exact
            path="/editserviceoffered"
            component={VendorServiceOfferedEdit}
          />
          <PrivateRoute
            exact
            path="/editcategoryliquortype"
            component={CategoryAndLiquorEdit}
          />
          <PrivateRoute
            exact
            path="/editpointofsale"
            component={EditPointOfSaleScreen}
          />
          <PrivateRoute
            exact
            path="/editfoodtype"
            component={VendorFoodTypeEdit}
          />
          <PrivateRoute
            exact
            path="/editcuisineoffered"
            component={VendorCuisineOfferedEdit}
          />
          <PrivateRoute
            exact
            path="/editbusinesshours"
            component={VendorBusinessHoursEdit}
          />
          <PrivateRoute
            exact
            path="/editbankdetails"
            component={VendorBankDetailsEdit}
          />
          {/***************************************************
           * @DESC START EDIT CASUAL DINING ORDERING
           **************************************************/}
          <PrivateRoute
            exact
            path="/edit-ordering-subscription"
            component={EditCasualDiningOrdering}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-subscription/takeaway"
            component={EditCasualTakeaway}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-subscription/curbside"
            component={EditCasualCurbside}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-subscription/dinein"
            component={EditCasualDinein}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-subscription/dinein/table"
            component={EditCasualDineinTableManagement}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-subscription/dinein/tableseatmanagement"
            component={EditCasualDineinTableSeatManagement}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-subscription/catering-banquet"
            component={EditCasualCateringBanquet}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-subscription/cateringbanquet/room"
            component={EditCasualCateringRoomManagementScreen}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-subscription/catering-banquet/seat"
            component={EditCasualCateringRoomSeatManagement}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-subscription/skiptheline"
            component={EditSkipLine}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-subscription/atmyseat"
            component={EditAtMySeatTableOrder}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-subscription/home-delivery"
            component={EditCasualHomeDelivery}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-subscription/separate-bank-account"
            component={EditCasualBankAccount}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-subscription/separate-bank-account/tipsaccount"
            component={EditCasualSeparateBankAccount}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-subscription/order-general-taxes"
            component={EditCasualGeneralSettingsTaxes}
          />
          <PrivateRoute
            exact
            path="/edit-experience-taxes"
            component={EditExperienceTaxes}
          />

          {/***************************************************
           * @DESC END EDIT CASUAL DINING ORDERING
           **************************************************/}
          {/***************************************************
           * @DESC START EDIT FAST FOOD ORDERING
           **************************************************/}
          <PrivateRoute
            exact
            path="/edit-ordering-fastfood-subscription"
            component={EditFastFoodOrdering}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-fastfood-subscription/takeaway"
            component={EditFastFoodTakeaway}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-fastfood-subscription/curbside"
            component={EditFastFoodCurbside}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-fastfood-subscription/dinein"
            component={EditFastFoodDinein}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-fastfood-subscription/skip-the-line"
            component={EditFastFoodSkiptheLine}
          />
          {/* <PrivateRoute
            exact
            path="/edit-ordering-fastfood-subscription/dinein/table"
            component={EditFastFoodDineinTableManagement}
          />
           <PrivateRoute
            exact
            path="/edit-ordering-fastfood-subscription/dinein/tableseatmanagement"
            component={EditFastFoodDineinTableSeatManagement}
          />*/}
          <PrivateRoute
            exact
            path="/edit-ordering-fastfood-subscription/catering-banquet"
            component={EditFastFoodCateringBanquet}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-fastfood-subscription/cateringbanquet/room"
            component={EditFastFoodCateringRoomManagementScreen}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-fastfood-subscription/catering-banquet/seat"
            component={EditFastFoodCateringRoomSeatManagement}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-fastfood-subscription/homedelivery"
            component={EditFastFoodHomeDelivery}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-fastfood-subscription/atmyseat-tableorder"
            component={EditFastFoodAtMySeatTableOrder}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-fastfood-subscription/separate-bank-account"
            component={EditFastFoodBankAccount}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-fastfood-subscription/separate-bank-account/tipsaccount"
            component={EditFastFoodSeparateBankAccount}
          />
          <PrivateRoute
            exact
            path="/edit-ordering-fastfood-subscription/order-general-taxes"
            component={EditFastFoodGeneralSettingsTaxes}
          />
          {/***************************************************
           * @DESC END EDIT FAST FOOD ORDERING
           **************************************************/}
          {/*************************************
           * @DESC Edit Vendor Offer Session
           **************************************/}
          <PrivateRoute
            exact
            path="/edit-offers-subscription"
            component={CasualDiningEditOffersManagement}
          />
          {/*************************************
           * @DESC Edit Vendor Scan & Pay
           **************************************/}
          <PrivateRoute
            exact
            path="/editscan-pay-subscription"
            component={CasualDiningEditScanAndPayScreen}
          />
          {/*************************************
           * @DESC Edit Vendor Live Streaming Session
           **************************************/}
          <PrivateRoute
            exact
            path="/edit-live-streaming"
            component={EditCasualLiveStreaming}
          />
          {/*************************************
           * @DESC Edit Vendor Event Session
           **************************************/}
          <PrivateRoute
            exact
            path="/edit-event-subscription"
            component={CasualDiningEditEventManagement}
          />
          <PrivateRoute
            exact
            path="/edit-event-subscription/edit-event-offline-subscription"
            component={OfflineEventsEditSubscription}
          />
          <PrivateRoute
            exact
            path="/edit-event-subscription/edit-event-online-subscription"
            component={OnlineEventsEditSubscription}
          />
          <PrivateRoute
            exact
            path="/edit-event-subscription/edit-event-offline-subscription/ticketbooking"
            component={EditTicketBookingPayment}
          />

          {/*************************************
           * @DESC Edit Vendor Seating Subscription
           **************************************/}
          <PrivateRoute
            exact
            path="/editseatingarea"
            component={SeatingAreaEditScreen}
          />
          <PrivateRoute
            exact
            path="/edit-seating-subscription"
            component={EditCasualDiningSeatingManagement}
          />
          <PrivateRoute
            exact
            path="/editgenralsettings"
            component={EditGenralSettingsScreen}
          />
          <PrivateRoute
            exact
            path="/editwalkinwaitlistsettings"
            component={EditWalkinWaitlistScreen}
          />
          <PrivateRoute
            exact
            path="/editreservationsettings"
            component={EditReservationSubscription}
          />
          <PrivateRoute
            exact
            path="/edit-table-management"
            component={EditMainTableManagementScreen}
          />
          <PrivateRoute
            exact
            path="/edit-table-seat-management"
            component={EditTableSeatManagement}
          />
          {/* /****************************************************************
              @DESC Edit Vendor Admin Link  
            *******************************************************************/}
          {/* <PrivateRoute
            exact
            path="/editcasualoffersubscription"
            component={ReservationSubscriptionEditScreen}
          />
          <PrivateRoute
            exact
            path="/editfastfoodoffersubscription"
            component={ReservationSubscriptionEditScreen}
          />
          <PrivateRoute
            exact
            path="/editcasualscanpaysubscription"
            component={ReservationSubscriptionEditScreen}
          />
          <PrivateRoute
            exact
            path="/editfastfoodscanpaysubscription"
            component={ReservationSubscriptionEditScreen}
          /> */}
          {/* <PrivateRoute
            exact
            path="/editcasualeventsubscription"
            component={EditCasualDiningEventManagementScreen}
          /> */}
          <PrivateRoute
            exact
            path="/rolemanagement"
            component={RoleManagement}
          />
          <PrivateRoute exact path="/addrole" component={AddRole} />
          <PrivateRoute
            exact
            path="/managehoursoperation"
            component={ManageHoursOperation}
          />
          <PrivateRoute
            exact
            path="/event-payment/:id"
            component={EventPayment}
          />
          <PrivateRoute exact path="/referrals" component={VendorReferrals} />
          <PrivateRoute
            exact
            path="/staffmanagement"
            component={StaffManagement}
          />
          <PrivateRoute exact path="/addstaff" component={AddStaff} />
          <PrivateRoute exact path="/editstaff" component={EditStaff} />
          <PrivateRoute exact path="/memolist" component={Memoslist} />
          <PrivateRoute exact path="/addmemo" component={AddMemo} />
          <PrivateRoute exact path="/viewmemo" component={ViewMemo} />
          <PrivateRoute exact path="/memopayment" component={MemoPayment} />
          {/* /****************************************************************
              @DESC Super Admin Link 
            *******************************************************************/}
          <AdminPrivateRoute
            exact
            path="/superadmindashboard"
            component={SuperAdminMainHomeComponent}
          />
          <AdminPrivateRoute
            exact
            path="/superadminallusers"
            component={MainSuperAdminUsers}
          />
          <AdminPrivateRoute
            exact
            path="/superadminviewusers/:userId"
            component={SuperAdminAllUsersView}
          />
          <AdminPrivateRoute
            exact
            path="/superadminallvendors"
            component={SuperAdminMainVendorComponent}
          />
          <AdminPrivateRoute
            exact
            path="/MarketingAndPromotionsDashbard"
            component={MarketingAndPromotionsDashbard}
          />
          <AdminPrivateRoute
            exact
            path="/superadminallpendingvendors"
            component={SuperAdminPendingVendorsComponent}
          />
          <AdminPrivateRoute
            exact
            path="/superadminvendorsratingview"
            component={VendorRatingReviewDisplayPage}
          />
          <AdminPrivateRoute
            exact
            path="/pendingvendorsprofileview"
            component={PendingVendorRatingReviewProfile}
          />
          <AdminPrivateRoute
            exact
            path="/activevendorsprofileview"
            component={VendorRatingReviewProfile}
          />
          <AdminPrivateRoute
            exact
            path="/superadminiconlist"
            component={SuperAdminMainListOfIcon}
          />
          <AdminPrivateRoute
            exact
            path="/superadminratingreviews"
            component={SuperAdminRatingReviews}
          />
          <AdminPrivateRoute
            exact
            path="/superadminsuggestion"
            component={SuperAdminSuggestion}
          />
          <AdminPrivateRoute
            exact
            path="/superadminnomination"
            component={SuperAdminMainNominations}
          />
          <AdminPrivateRoute
            exact
            path="/openissuesusers"
            component={SuperAdminOpenIssuesUsers}
          />
          <AdminPrivateRoute
            exact
            path="/openissuesviewusers/:issueId"
            component={SuperAdminViewUsersTickets}
          />
          <AdminPrivateRoute
            exact
            path="/openissuesvendors"
            component={SuperAdminOpenIssuesVendor}
          />
          <AdminPrivateRoute
            exact
            path="/adminopenissuesviewvendors/:issueId"
            component={SuperAdminViewVendorsTickets}
          />
          {/* <AdminPrivateRoute
            exact
            path="/openissueseditvendors"
            component={SuperAdminEditVendorsTickets}
          /> */}
          <AdminPrivateRoute
            exact
            path="/superadminreports"
            component={SuperAdminReportsMain}
          />
          <AdminPrivateRoute
            exact
            path="/superadminuserfavorite"
            component={SuperAdminMainUserFavorites}
          />
          <AdminPrivateRoute
            exact
            path="/superadminviewnominations/:viewIndex"
            component={SuperAdminNominatioViewPage}
          />
          <AdminPrivateRoute
            exact
            path="/superadminnominationsdetailsactivity"
            component={SuperAdminNominationViewActivity}
          />
          <AdminPrivateRoute
            exact
            path="/superadminoffers"
            component={SuperAdminOffers}
          />
          <AdminPrivateRoute
            exact
            path="/superadminuserviewactivity"
            component={SuperAdminUserViewUsed}
          />
          <AdminPrivateRoute
            exact
            path="/salesRepresentativedashboard"
            component={salesRepresentativedashboard}
          />
          <AdminPrivateRoute
            exact
            path="/superadmindunzoDeliverySettings"
            component={DunzoDeliverySettings}
          />
          <AdminPrivateRoute
            exact
            path="/addDunzoPartners"
            component={AddDunzoPartners}
          />
          <AdminPrivateRoute
            exact
            path="/superadmindunzostatement"
            component={DunzoStatement}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/dunzo/settlements/restaurants"
            component={DunzoStatementRestaurants}
          />
          <AdminPrivateRoute
            exact
            path="/dunzosetting/viewstatement"
            component={DunzoStatements}
          />
          <AdminPrivateRoute
            exact
            path="/superadminposdashboard"
            component={PosDetails}
          />
          <AdminPrivateRoute
            exact
            path="/superadminpospriceupdatereport"
            component={PosPriceUpdateReport}
          />
          <AdminPrivateRoute exact path="/AddPos" component={AddPos} />
          <AdminPrivateRoute exact path="/AddPos/:id" component={AddPos} />
          <AdminPrivateRoute
            exact
            path="/adminposloginreport"
            component={PosLoginReport}
          />
          <AdminPrivateRoute
            exact
            path="/AffiliatesDashboard"
            component={AffiliatesDashboard}
          />
          <AdminPrivateRoute
            exact
            path="/SuperAdminPartnerDashboard"
            component={SuperAdminPartnersDashboard}
          />
          <AdminPrivateRoute
            exact
            path="/SuperAdminReferralRewarddashboard"
            component={SuperAdminReferralRewarddashboard}
          />
          <AdminPrivateRoute
            exact
            path="/SuperAdminValidatereferralrewardprogram"
            component={SuperAdminValidatereferralrewardprogram}
          />
          <AdminPrivateRoute
            exact
            path="/superAdminApprovedreferrals"
            component={SuperAdminApprovedreferrals}
          />
          <AdminPrivateRoute
            exact
            path="/userRegistrationAmealio"
            component={UserRegistrationAmealio}
          />
          <AdminPrivateRoute
            exact
            path="/SuperAdminReferralRewarddashboard/AddReferralProgram"
            component={AddRefferalprogram}
          />
          <AdminPrivateRoute
            exact
            path="/SuperAdminReferralRewarddashboard/edit-referral-reward-request/:id"
            component={EditReferralReward}
          />
          <AdminPrivateRoute
            exact
            path="/restaurantadminoffers"
            component={SuperAdminRestaurantOffers}
          />
          <AdminPrivateRoute
            exact
            path="/superadminreferralcode"
            component={SuperAdminReferralsCode}
          />
          <AdminPrivateRoute
            exact
            path="/superadminuserfavorite/group"
            component={SuperAdminMainUserFavoritesGroup}
          />
          <AdminPrivateRoute
            exact
            path="/superadminuserfavorite/group/restaurant"
            component={SuperAdminMainUserFavoritesGroupRestaurant}
          />
          <AdminPrivateRoute
            exact
            path="/superadminuserfavorite/group/offer"
            component={SuperAdminMainUserFavoritesGroupOffer}
          />
          <AdminPrivateRoute
            exact
            path="/superadminuserfavorite/group/event"
            component={SuperAdminMainUserFavoritesGroupEvent}
          />
          <AdminPrivateRoute
            exact
            path="/closewallet"
            component={UserCloseWalletRequests}
          />
          <AdminPrivateRoute
            exact
            path="/deleteUsers"
            component={DeleteUsersList}
          />
          <AdminPrivateRoute
            exact
            path="/retainedUsers"
            component={RetainedUsersList}
          />
          <AdminPrivateRoute
            exact
            path="/closewallet"
            component={UserCloseWalletRequests}
          />
          <AdminPrivateRoute exact path="/adduser" component={AddUser} />
          <AdminPrivateRoute
            exact
            path="/addvendor"
            component={SuperAdminAddVendorSignup}
          />
          <AdminPrivateRoute
            exact
            path="/addvendormapdetails"
            component={SuperAdminAddMapDetails}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_mapdetails"
            component={SuperAdminAddMapDetails}
          />
          <AdminPrivateRoute
            exact
            path="/addvendormapdetailslocation"
            component={SuperAdminAddMapDetailsTwo}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_mapdetails_location"
            component={SuperAdminAddMapDetailsTwo}
          />
          <AdminPrivateRoute
            exact
            path="/addvendorbusinessdetails"
            component={SuperAdminAddBusinessDetails}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_business_details"
            component={SuperAdminAddBusinessDetails}
          />
          <AdminPrivateRoute
            exact
            path="/addvendorpointofcontact"
            component={SuperAdminAddPointOfContact}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_point_of_contact"
            component={SuperAdminAddPointOfContact}
          />
          <AdminPrivateRoute
            exact
            path="/addvendorrestauraninfo"
            component={SuperAdminAddRestaurantDetails}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_restauran_info"
            component={SuperAdminAddRestaurantDetails}
          />
          <AdminPrivateRoute
            exact
            path="/addvendorchain"
            component={SuperAdminRestaurantChain}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_marchant_chain"
            component={SuperAdminRestaurantChain}
          />
          <AdminPrivateRoute
            exact
            path="/addvendorrestauranttype"
            component={SuperAdminRestaurantTypeComponent}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_restaurant_type"
            component={SuperAdminRestaurantTypeComponent}
          />
          <AdminPrivateRoute
            exact
            path="/addvendorpayment"
            component={SuperAdminVendorPaymentMethod}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_merchant_payment"
            component={SuperAdminVendorPaymentMethod}
          />
          <AdminPrivateRoute
            exact
            path="/addvendorparking"
            component={SuperAdminVendorParking}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_merchant_parking"
            component={SuperAdminVendorParking}
          />
          <AdminPrivateRoute
            exact
            path="/addvendorpetsallowed"
            component={SuperAdminVendorPetsAllowed}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_pets_allowed"
            component={SuperAdminVendorPetsAllowed}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/offerused"
            component={SuperAdminOfferUsed}
          />
          <AdminPrivateRoute
            exact
            path="/addvendordresscode"
            component={SuperAdminVendorDressCode}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_dress_code"
            component={SuperAdminVendorDressCode}
          />
          <AdminPrivateRoute
            exact
            path="/addvendoraccessiblity"
            component={SuperAdminVendorAccessiblity}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_accessiblity"
            component={SuperAdminVendorAccessiblity}
          />
          <AdminPrivateRoute
            exact
            path="/addvendorotherfeatures"
            component={SuperAdminVendorOtherFeatures}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_otherfeatures"
            component={SuperAdminVendorOtherFeatures}
          />
          <AdminPrivateRoute
            exact
            path="/addvendorserviceoffered"
            component={SuperAdminVendorServiceOffered}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_serviceoffered"
            component={SuperAdminVendorServiceOffered}
          />
          <AdminPrivateRoute
            exact
            path="/addvendorlocatedinside"
            component={SuperAdminVendorLocatedInside}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_locatedinside"
            component={SuperAdminVendorLocatedInside}
          />
          <AdminPrivateRoute
            exact
            path="/addvendorpointofsale"
            component={SuperAdminVendorPointOfSale}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_pointofsale"
            component={SuperAdminVendorPointOfSale}
          />
          <AdminPrivateRoute
            exact
            path="/addvendorhealthAndsenitation"
            component={SuperAdminVendorHealthAndSenitation}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_healthAndsenitation"
            component={SuperAdminVendorHealthAndSenitation}
          />
          <AdminPrivateRoute
            exact
            path="/addvendorcuisinesetup"
            component={SuperAdminVendorCuisineSetup}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_cuisinesetup"
            component={SuperAdminVendorCuisineSetup}
          />
          <AdminPrivateRoute
            exact
            path="/addvendorfoodtype"
            component={SuperAdminVendorFoodType}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_foodtype"
            component={SuperAdminVendorFoodType}
          />
          <AdminPrivateRoute
            exact
            path="/addvendorcuisineoffered"
            component={SuperAdminVendorCuisineOffered}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_cuisineoffered"
            component={SuperAdminVendorCuisineOffered}
          />
          <AdminPrivateRoute
            exact
            path="/addvendorbusinesshours"
            component={SuperAdminVendorBusinessHours}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_businesshours"
            component={SuperAdminVendorBusinessHours}
          />
          <AdminPrivateRoute
            exact
            path="/addvendorbankdetails"
            component={SuperAdminVendorBankDetails}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_bankdetails"
            component={SuperAdminVendorBankDetails}
          />
          {/* <AdminPrivateRoute
            exact  
            path="/addvendorbankdetails"
            component={SuperAdminVendorBankDetails}
          /> */}
          <AdminPrivateRoute
            exact
            path="/addAdmintermcondition"
            component={AdminTermsAndConditions}
          />
          <AdminPrivateRoute
            exact
            path="/admin_edit_termcondition"
            component={AdminTermsAndConditions}
          />
          {/* // experiences links SupeerAdmin // */}
          <AdminPrivateRoute
            exact
            path="/superadmin/experience/pages"
            component={CurationPage}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/experience/pages/:page_id"
            component={PageSections}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/experience/page/section/expsinsection/:page_id/:section_id"
            component={AddExpToTopSection}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/experience/page/section/addexptosection/:page_id/:section_id"
            component={AddExp}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/experience/section/:page_id"
            component={AddSection}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/experience/section/:page_id/edit/:section_id"
            component={AddSection}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/experience/addpages"
            component={Addpages}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/experience/editpages/:page_id"
            component={Addpages}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/experience/reports/activity/pending"
            component={SuperAdminSeatingPendingExperienceReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/experience/reports/activity/special"
            component={SuperAdminSeatingActivityExperienceReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/experience/reports/activity/curated"
            component={SuperAdminSeatingActivityExperienceReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/experience/dashboard/all"
            component={AllExperienceDashboard}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/experience/merchant/management"
            component={MerchantExperienceManagementDashboard}
          />
          {/* /****************************************************************
              @DESC Super Admin Onboarding Process Link  
            *******************************************************************/}
          <AdminPrivateRoute
            exact
            path="/admin-subscription"
            component={AdminScreenDescription}
          />
          <AdminPrivateRoute
            exact
            path="/admin-edit-subscription"
            component={AdminScreenDescription}
          />
          <AdminPrivateRoute
            exact
            path="/admin-add-subscription"
            component={AdminViewSubscription}
          />
          <AdminPrivateRoute
            exact
            path="/admin-edit-add-subscription"
            component={AdminViewSubscription}
          />
          <AdminPrivateRoute
            exact
            path="/admin-edit-experience-taxes"
            component={AdminEditExperienceTaxes}
          />

          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/offers"
            component={AdminCasualDiningOffers}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/scanandpay"
            component={AdminCasualDiningScanAndPay}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/events"
            component={AdminCasualDiningEventManagement}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/experiences"
            component={AdminExperienceManagementScreen}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/experience"
            component={AdminCasualDiningExperienceManagement}
          />

          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/event/offline"
            component={AdminOfflineEventsSubscription}
          />

          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/experience/offline"
            component={AdminOfflineExperienceSubscription}
          />

          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/event/offline/ticketbooking"
            component={AdminTicketBookingPayment}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/experience/offline/ticketbooking"
            component={AdminTicketExpBookingPayment}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/event/online"
            component={AdminOnlineEventsSubscription}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/livestreaming"
            component={AdminCasualDiningLiveStreaming}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/seatingmanagement"
            component={AdminCasualDiningSeatingManagement}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/seatingmanagement/generalseating"
            component={AdminGenralSeating}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/seatingmanagement/walkinwaitlist"
            component={AdminWalkinWaitlist}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/seatingmanagement/reservation"
            component={AdminReservationSeating}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/seatingmanagement/table"
            component={AdminTableManagement}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/seatingmanagement/tableseatmanagement"
            component={AdminTableSeatManagement}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/ordering"
            component={AdminCasualDiningOrdering}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/ordering/takeaway"
            component={AdminTakeaway}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/ordering/curbside"
            component={AdminCurbside}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/ordering/dinein"
            component={AdminDinein}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/ordering/dinein/table"
            component={AdminDineinTableManagement}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/ordering/dinein/tableseatmanagement"
            component={AdminDineinTableSeatManagement}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/ordering/cateringbanquet"
            component={AdminCateringBanquet}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/ordering/cateringbanquet/room"
            component={AdminCateringRoomManagement}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/ordering/cateringbanquet/roomseatmanagement"
            component={AdminCateringRoomSeatManagement}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/ordering/homedelivery"
            component={AdminHomeDelivery}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/ordering/bankaccount"
            component={AdminBankAccount}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/ordering/separatebankaccount"
            component={AdminSeparateBankAccount}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/ordering/generalsettingstaxes"
            component={AdminGeneralSettingsTaxes}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/menusetup"
            component={AdminMenuSetup}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/menusetup/selectmenu/cuisine"
            component={AdminCuisine}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/menusetup/selectmenu/categorytype"
            component={AdminCategoryType}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/menusetup/crossselling"
            component={AdminCrossSelling}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/menusetup/selectmenu/selectedcategories"
            component={AdminSelectedCategories}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/menusetup/selectmenu/selecteditemsnew"
            component={AdminSelectedItemsNew}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/menusetup/selectmenu/editcategories"
            component={AdminEditCategories}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/menusetup/selectmenu/selectitems"
            component={AdminSelectItems}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/menusetup/selectmenu/selectitemsnew"
            component={AdminSelectItemsNew}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/menusetup/selectmenu/selecteditems"
            component={AdminSelectedItems}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/menusetup/uploadmenu"
            component={AdminUploadMenu}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/menusetup/addcategory"
            component={AdminAddCategories}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/menusetup/addcategory/catalog"
            component={AdminAddCategories}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/menusetup/additem"
            component={AdminAddItem}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/menusetup/additem/catalog"
            component={AdminAddItem}
          />
          {/********************************************
            @DESC FAST FOOD MANAGEMENT SUBSCRIPTION
          *********************************************/}
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/offers"
            component={FastFoodOffersManagement}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/scanandpay"
            component={FastFoodScanAndPayScreen}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/livestreaming"
            component={FastFoodLiveStreamingScreen}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/ordering"
            component={FastFoodOrderingScreen}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/ordering/takeaway"
            component={FastFoodTakeaway}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/ordering/curbside"
            component={FastFoodCurbside}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/ordering/dinein"
            component={FastFoodDinein}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/ordering/cateringbanquet"
            component={FastFoodCateringBanquet}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/ordering/homedelivery"
            component={FastFoodHomeDelivery}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/ordering/bankaccount"
            component={FastFoodBankAccount}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/ordering/separatebankaccount"
            component={FastFoodSeparateBankAccount}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/ordering/generalsettingstaxes"
            component={FastFoodGeneralSettingsTaxes}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/menusetup"
            component={FastFoodMenuSetup}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/menusetup/selectmenu/cuisine"
            component={FastFoodCuisine}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/menusetup/selectmenu/categorytype"
            component={FastFoodCategoryType}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/menusetup/crossselling"
            component={FastFoodCrossSelling}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/menusetup/selectmenu/selectedcategories"
            component={FastFoodSelectedCategories}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/menusetup/selectmenu/editcategories"
            component={FastFoodEditCategories}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/menusetup/selectmenu/selectitems"
            component={FastFoodSelectItems}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/menusetup/selectmenu/selecteditems"
            component={FastFoodSelectedItems}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/menusetup/uploadmenu"
            component={FastFoodUploadMenu}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/menusetup/addcategory"
            component={FastFoodAddCategories}
          />
          <AdminPrivateRoute
            exact
            path="/admin-fastfood/menusetup/additem"
            component={FastFoodAddItem}
          />
          {/* <AdminPrivateRoute
            exact
            path="/casual-fine-dining/seating/table"
            component={TableSeatManagement}
          /> *
          <AdminPrivateRoute
            exact
            path="/subscriptionhome"
            component={MainSubscriptionComponent}
          /> */}
          {/********************************************
            @DESC MULTI SERVICE MANAGEMENT SUBSCRIPTION
          ********************************************/}
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/offers"
            component={MultiServiceOffersManagement}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/scanandpay"
            component={MultiServiceScanAndPayScreen}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/events"
            component={MultiServiceEventManagementScreen}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/event/offline"
            component={MultiServiceOfflineEventsSubscription}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/event/offline/ticketbooking"
            component={MultiServiceTicketBookingPayment}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/event/online"
            component={MultiServiceOnlineEventsSubscription}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/livestreaming"
            component={MultiServiceLiveStreamingScreen}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/seatingmanagement"
            component={MultiServiceSeatingManagementScreen}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/seatingmanagement/generalseating"
            component={MultiServiceGenralSeatingScreen}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/seatingmanagement/walkinwaitlist"
            component={MultiServiceWalkinWaitlistScreen}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/seatingmanagement/reservation"
            component={MultiServiceReservationSeatingScreen}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/seatingmanagement/table"
            component={MultiServiceTableManagementScreen}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/seatingmanagement/tableseatmanagement"
            component={MultiServiceTableSeatManagement}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/ordering"
            component={MultiServiceOrderingScreen}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/ordering/takeaway"
            component={MultiServiceTakeaway}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/ordering/curbside"
            component={MultiServiceCurbside}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/ordering/dinein"
            component={MultiServiceDinein}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/ordering/skiptheline"
            component={MultiServiceSkipTheLine}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/ordering/atmyseattable"
            component={MultiServiceAtMySeatTable}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/ordering/dinein/table"
            component={MultiServiceDineinTableManagementScreen}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/ordering/dinein/tableseatmanagement"
            component={MultiServiceDineinTableSeatManagement}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/ordering/cateringbanquet"
            component={MultiServiceCateringBanquet}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/ordering/cateringbanquet/room"
            component={MultiServiceCateringRoomManagementScreen}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/ordering/cateringbanquet/roomseatmanagement"
            component={MultiServiceCateringRoomSeatManagement}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/ordering/homedelivery"
            component={MultiServiceHomeDelivery}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/ordering/bankaccount"
            component={MultiServiceBankAccount}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/ordering/separatebankaccount"
            component={MultiServiceSeparateBankAccount}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/ordering/generalsettingstaxes"
            component={MultiServiceGeneralSettingsTaxes}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/menusetup"
            component={MenuSetup}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/menusetup/selectmenu/cuisine"
            component={Cuisine}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/menusetup/selectmenu/categorytype"
            component={CategoryType}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/menusetup/crossselling"
            component={CrossSelling}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/menusetup/selectmenu/selectedcategories"
            component={SelectedCategories}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/menusetup/selectmenu/selecteditemsnew"
            component={SelectedItemsNew}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/menusetup/selectmenu/editcategories"
            component={EditCategories}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/menusetup/selectmenu/selectitems"
            component={SelectItems}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/menusetup/selectmenu/selectitemsnew"
            component={SelectItemsNew}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/menusetup/selectmenu/selecteditems"
            component={SelectedItems}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/menusetup/uploadmenu"
            component={UploadMenu}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/menusetup/addcategory"
            component={AddCategories}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/menusetup/addcategory/catalog"
            component={AddCategories}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/menusetup/additem"
            component={AddItem}
          />
          <AdminPrivateRoute
            exact
            path="/admin-multi-service/menusetup/additem/catalog"
            component={AddItem}
          />
          <MerchantDashboardAndOnboardingRoute
            exact
            path="/admin-multi-service/experience-management"
            component={ExperienceManagementScreen}
          />
          <MerchantDashboardAndOnboardingRoute
            exact
            path="/admin-multi-service/experience-management/offline"
            component={OfflineExperienceManagement}
          />
          <MerchantDashboardAndOnboardingRoute
            exact
            path="/admin-multi-service/experience-management/offline/special"
            component={SpecialOfflineExperienceManagement}
          />
          <MerchantDashboardAndOnboardingRoute
            exact
            path="/admin-multi-service/experience-management/offline/curated"
            component={CuratedOfflineExperienceManagement}
          />
          {/***************************************
           * @DESC SUPER ADMIN SUBSCRIPTION
           ***************************************/}
          <AdminPrivateRoute
            exact
            path="/superadminoffers/add-vendor-offer"
            component={AddNewOffer}
          />
          <AdminPrivateRoute
            exact
            path="/superadminoffers/add-admin-offer"
            component={AdminAddNewOffer}
          />
          <AdminPrivateRoute
            exact
            path="/superadminseatingdashboard"
            component={MainSeatingComponent}
          />
          <AdminPrivateRoute
            exact
            path="/superadmindashboard/adminadddiner"
            component={AdminAddDiner}
          />
          <AdminPrivateRoute
            exact
            path="/superadminoffers/edit-admin-offline-offer/:offerId"
            component={EditAdminOfflineOffer}
          />
          <AdminPrivateRoute
            exact
            path="/superadminoffers/edit-admin-online-offer/:offerId"
            component={EditAdminOnlineOffer}
          />
          <AdminPrivateRoute
            exact
            path="/superadminoffers/edit-offline-offer/:offerId"
            component={EditOfflineOffer}
          />
          <AdminPrivateRoute
            exact
            path="/superadminoffers/edit-online-offer/:offerId"
            component={EditOnlineOffer}
          />
          <AdminPrivateRoute
            exact
            path="/superadminrestaurantevents"
            component={SuperAdminRestaurantEvents}
          />
          <AdminPrivateRoute
            exact
            path="/superadminrestaurantevents/online-event-details/:id"
            component={SuperAdminEvnetsOnline}
          />
          <AdminPrivateRoute
            exact
            path="/superadminrestaurantevents/add-event"
            component={AddNewEvent}
          />
          <AdminPrivateRoute
            exact
            path="/superadminrestaurantevents/edit-offline-event/:eventId"
            component={EditOfflineEvent}
          />
          <AdminPrivateRoute
            exact
            path="/superadminrestaurantevents/edit-online-event/:eventId"
            component={EditOnlineEvent}
          />
          <AdminPrivateRoute
            exact
            path="/superadminscanpay"
            component={SuperAdminScanPay}
          />
          <AdminPrivateRoute
            exact
            path="/superadminuserwithdrawalrequests"
            component={SuperAdminUserWallatTransactions}
          />
          <AdminPrivateRoute
            exact
            path="/superadminuserwallattransactions"
            component={SuperAdminUserWallatTransactionsMain}
          />
          <AdminPrivateRoute
            exact
            path="/superadmindonation"
            component={SuperAdminDonation}
          />
          <AdminPrivateRoute
            exact
            path="/superadmindonationreport"
            component={SuperAdminDonationReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadmindonationdetails/:OrganizationId/:SettleMentId/:DonationType"
            component={SuperAdminDonationDetails}
          />
          <AdminPrivateRoute
            exact
            path="/superadminordersactivity"
            component={SuperAdminOrders}
          />
          <AdminPrivateRoute
            exact
            path="/superadminallorders"
            component={SuperAdminAllOrders}
          />
          <AdminPrivateRoute
            exact
            path="/superadminpendingordersactivity"
            component={SuperAdminPendingOrders}
          />
          <AdminPrivateRoute
            exact
            path="/cancelledorders"
            component={CancelledOrders}
          />
          <AdminPrivateRoute
            exact
            path="/superadmincreateorder"
            component={SuperAdminCreateOrders}
          />
          <AdminPrivateRoute
            exact
            path="/superadmineventmanagement"
            component={SuperAdminEventManagement}
          />
          <AdminPrivateRoute
            exact
            path="/superadminvendororderprivate"
            component={SuperAdminVendorOrdersPrivate}
          />
          <AdminPrivateRoute
            exact
            path="/superadminordering"
            component={SuperAdminMainComponent}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-offline-events-details/:id"
            component={OfflineEventDetailsScreen}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-offline-events-pending"
            component={SuperAdminOfflineEventsPending}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-offline-events-booked/:id"
            component={SuperAdminOfflineEventsBooked}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-offline-events-history"
            component={SuperAdminOfflineEventsHistory}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-offline-events-all"
            component={SuperAdminOfflineEventAll}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-offline-events/add-event"
            component={AddEvent}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-refrees"
            component={SuperAdminRefrees}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-referrals"
            component={SuperAdminReferrals}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-order-reports"
            component={SuperAdminOrderReports}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-pending-chains-vendor"
            component={SuperAdminPendingChainsVendor}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-active-chains-vendor"
            component={SuperAdminActiveChainsVendor}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/merchant-promotions"
            component={SuperAdminMerchantPromotion}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/merchant-maintain-tags"
            component={SuperAdminMaintainMerchantTags}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/merchant-validate-tags"
            component={SuperAdminValidateMerchantTags}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/merchant-approve-tags"
            component={SuperAdminApproveMerchantTags}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-add-chains-vendor"
            component={SuperAdminAddChainsVendor}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-global-catalogue/add-catalogue"
            component={SuperAdminAddGlobalCatalogue}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-global-catalogue"
            component={SuperAdminGlobalCatalogue}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-chain-catalogue/add-catalogue"
            component={SuperAdminAddChainCatalogue}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-global-catalogue/catalogue/:id"
            component={SuperAdminCatalogueView}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-chain-catalogue/catalogue/:id"
            component={SuperAdminCatalogueView}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-global-catalogue/assign-item"
            component={AssignItem}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-chain-catalogue/assign-item"
            component={AssignChainItem}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-global-catalogue/add-item"
            component={AddItemCatalogue}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-chain-catalogue/add-item"
            component={AddItemChain}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-global-items-management/:pageurl"
            component={SuperAdminGlobalItemsManagement}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-global-catalogue/add-category"
            component={SuperAdminGlobalAddCategory}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-chain-items-management/:pageurl"
            component={SuperAdminChainItemsManagement}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-chain-catalogue/add-category"
            component={SuperAdminChainAddCategory}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-chain-catalogue/add-item"
            component={AddItemCatalogue}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-role-management"
            component={SuperAdminRoleManagement}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-add-role"
            component={SuperAdminAddRole}
          />
          <AdminPrivateRoute
            exact
            path="/superadminopenitemsettlement"
            component={SuperAdminItemsforSettlement}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/request-checkout"
            component={SuperAdminRequestCheckout}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/initiated-settlement"
            component={SuperAdminInitiatedSettlement}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/approvedSettlement"
            component={SuperAdminProcessedSettlement}
          />
          <AdminPrivateRoute
            exact
            path="/merchant-statement"
            component={AllMerchantStatement}
          />
          <AdminPrivateRoute
            exact
            path="/resetstatement"
            component={SuperAdminResetClearSettlement}
          />
          <AdminPrivateRoute
            exact
            path="/unsetstatement"
            component={SuperAdminResetUnclearSettlement}
          />
          <AdminPrivateRoute
            exact
            path="/merchant-statement/:vendorId"
            component={MerchantStatementDetail}
          />
          <AdminPrivateRoute
            exact
            path="/superadminpayoutdetails/:id"
            component={SuperadminPayoutDetails}
          />
          <AdminPrivateRoute
            exact
            path="/superadminpayoutviewdetails/:id"
            component={SuperadminPayoutViewDetails}
          />
          <AdminPrivateRoute
            exact
            path="/superadminviewpayoutdetails/:id"
            component={SuperAdminViewPayoutDetails}
          />
          <AdminPrivateRoute
            exact
            path="/superadminpayouthistory/:vendorId"
            component={SuperadminPayoutHistory}
          />
          <AdminPrivateRoute
            exact
            path="/superadminorderrefundandcancellation"
            component={SuperAdminOrderRefundAndCancellation}
          />
          <AdminPrivateRoute
            exact
            path="/superadminfaqmanagement"
            component={SuperadminFAQManagement}
          />
          <AdminPrivateRoute
            exact
            path="/superadminchatmanagement"
            component={SuperAdminChatManagement}
          />
          <AdminPrivateRoute
            exact
            path="/superadminnotifyusers"
            component={SuperAdminNotifyUsers}
          />
          <AdminPrivateRoute
            exact
            path="/superadminnotifyusersadd"
            component={SuperAdminNotifyUsersCreate}
          />
          <AdminPrivateRoute
            exact
            path="/superadminsmstemplatemanagement"
            component={SuperAdminSMSTemplateManagement}
          />
          <AdminPrivateRoute
            exact
            path="/superadminaddtemplate"
            component={SuperAdminAddSmsTemplate}
          />
          <AdminPrivateRoute
            exact
            path="/super-admin-edit-template"
            component={SuperAdminEditTemplate}
          />
          <AdminPrivateRoute
            exact
            path="/superadminemailtemplatemanagement"
            component={SuperAdminEmailTemplateManagement}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin-notification-templatemanagement"
            component={SuperAdminNotificationTemplate}
          />
          <AdminPrivateRoute
            exact
            path="/superadminnonprofitorg"
            component={SuperAdminNonProfitOrg}
          />
          <AdminPrivateRoute
            exact
            path="/superadminaddnonprofitorg"
            component={SuperAdminAddNonProfitOrg}
          />
          {/* <AdminPrivateRoute
            exact
            path="/superadmininvoices"
            component={SuperAdminInvoices}
          /> */}
          {/* // user analytics reports // */}
          <AdminPrivateRoute
            exact
            path="/superadmin/reports/restaurants"
            component={RestaurantAnalytics}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/reports/amealiogeneral"
            component={AmealiogeneralAnalytics}
          />
          <AdminPrivateRoute
            exact
            path="/superadminordertaxsummaryreports"
            component={SuperAdminOrderTaxSummaryReports}
          />
          <AdminPrivateRoute
            exact
            path="/admindeliveryreports"
            component={SuperAdminDeliveryOrderReport}
          />
          <AdminPrivateRoute
            exact
            path="/admindeliverycancelledreports"
            component={SuperAdminDeliveryCancelledOrderReport}
          />
          <AdminPrivateRoute
            exact
            path="/admindunzotransactions"
            component={SuperAdminDunzoTransactions}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/paymentactivitysummaryreports"
            component={SuperAdminPaymentActivitySummaryReportss}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/paymentactivityreports/:id"
            component={SuperAdminPaymentActivityReports}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/paymentactivitysummaryreportsvendor/:id"
            component={SuperAdminPaymentSummaryReoportsVendor}
          />
          <AdminPrivateRoute
            exact
            path="/superadminordertaxvendorreports/:id"
            component={SuperAdminOrderTaxVendorReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadminorderitemsalesreport"
            component={SuperAdminOrderItemSalesTaxReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadminseatingpendingactivityreport"
            component={SuperAdminSeatingPendingActivityReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadminseatingactivityreport"
            component={SuperAdminSeatingActivityReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadminseatingall"
            component={SuperAdminSeatingAll}
          />
          {/* Super Admin -> Vendor Seating Routes */}
          <AdminPrivateRoute
            exact
            path="/superadmin/vendorseating"
            component={SuperAdminMainSeatingDashboard}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/vendorseating/reservation"
            component={SuperAdminMainReservation}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/vendorseating/pending"
            component={SuperAdminMainPendingDashboard}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/vendorseating/history"
            component={SuperAdminSeatingMainHistoryDashboard}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/vendorseating/add-diner"
            component={AdminAddDinerReservation}
          />
          {/* <AdminPrivateRoute
            exact
            path="/superadmin/vendorseating/add-diner"
            component={SuperAdminAddDiner}
          /> */}
          <AdminPrivateRoute
            exact
            path="/superadminvendorseatingsummaryreports"
            component={VendorSeatingSummaryReports}
          />
          <AdminPrivateRoute
            exact
            path="/superadminordersummaryreport"
            component={SuperAdminOrderSummaryReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadminordervendorreport/:id"
            component={SuperAdminOrderVendorReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadminpendingorderactivityreport"
            component={SuperAdminPendingOrderActivityReports}
          />
          <AdminPrivateRoute
            exact
            path="/superadminorderitemsalestaxvendorreport/:id"
            component={SuperAdminOrderItemSalesTaxVendorReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadminorderitemsalestaxsummaryreport"
            component={SuperAdminOrderItemSalesTaxSummaryReports}
          />
          <AdminPrivateRoute
            exact
            path="/superadminorderrefundcancellationsummaryreports"
            component={SuperAdminOrderRefundCancellationSummaryReports}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/orderrefundcancellationactivityreports"
            component={SuperAdminOrderRefundCancellationActivityReports}
          />
          <AdminPrivateRoute
            exact
            path="/superadminorderrefundcancellationvendorreports/:id"
            component={SuperAdminOrderRefundCancellationVendorReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadminsettlementsummaryreport"
            component={SuperAdminSettlementSummaryReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadminordersettlementreport"
            component={SuperAdminOrderSettlementReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadmineventticketactivity"
            component={SuperAdminEventTicketActivity}
          />
          <AdminPrivateRoute
            exact
            path="/superadmininvoice"
            component={SuperAdminInvoice}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/paymentactivityreports"
            component={SuperAdminPaymentActivityReports}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/settlements/summaryreports-vendor/:id"
            component={SuperAdminSettlementSummaryReportsVendor}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/scanandpayactivityreport"
            component={ScanAndPayActivityReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/scanandpaysummaryreport"
            component={ScanAndPaySummaryReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/scanandpayvendorreport/:id"
            component={ScanAndPayVendorReport}
          />
          {/* teja admin- dev */}
          <AdminPrivateRoute
            exact
            path="/superadmin/eventsummaryreports"
            component={EventSummaryReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/offersactivityreports"
            component={OffersActivity}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/allseatingactivityreports"
            component={AllSeatingActivityReports}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/offersummaryreports"
            component={OfferSummaryReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/offervendorreports/:vendor_id/:id"
            component={OfferVendorReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/eventvendorreports/:id"
            component={EventVendorReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/vendorreports"
            component={SuperAdminVendorReportsStauts}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/allorderactivityreports"
            component={AllOrderActivityReports}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/pendingorderactivityreports"
            component={PendingOrderActivityReports}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/seatingpendingreports"
            component={SeatingPendingActivityReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/seatingsummaryreports"
            component={SeatingSummaryReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/seatingvendorreports/:id"
            component={SeatingVendorReports}
          />
          <AdminPrivateRoute
            exact
            path="/seatinganalytics"
            component={SeatingAnalytics}
          />
          <AdminPrivateRoute
            exact
            path="/menuitemsummaryreport"
            component={MenuItemSummaryReport}
          />
          <AdminPrivateRoute
            exact
            path="/vendoritemreport/:id/:restaurant_id"
            component={VendorItemReport}
          />
          <AdminPrivateRoute
            exact
            path="/menuitemactivityreport"
            component={MenuItemActivityReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/ordertaxactivityreports"
            component={SuperAdminOrderTaxActivityReports}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/reports-charts"
            component={SuperAdminMainReportsDashboard}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/userwallet/add"
            component={SuperAdminUserWallet}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/userwallet"
            component={SuperAdminUserWalletDashboard}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/userwallet/allreferrals"
            component={SuperAdminUserWalletAllReferrals}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/userwallet/transfermoneyrequest"
            component={SuperAdminUserWalletTransferMoneyRequest}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/userwallet/transfermoneyrequest/approved-process"
            component={SuperAdminUserTransferMoneyProcess}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/userwallet/addremovemoneyrequest"
            component={SuperAdminUserWalletAddRemoveMoneyRequest}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/userwallet/approved-process"
            component={SuperAdminUserProcess}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/departmentwallet"
            component={SuperAdminDepartmentalWallet}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/departmentwallet/add"
            component={SuperAdminDepartmentalWalletAdd}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/departmentwallet/approved-process"
            component={SuperAdminDepartmentalProcess}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/departmentwallet/addremovemoneyrequest"
            component={SuperAdminDepartmentalWalletAddRemoveMoneyRequest}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/errorlogs"
            component={SuperAdminErrorLogs}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/promotional-videos"
            component={SuperAdminPromotionalVideos}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/promotional-videos/add"
            component={AdminAddNewVideo}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/short-videos"
            component={SuperAdminShortVideoDashboard}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/short-videos/add"
            component={AdminAddShortVideo}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/short-videos/edit/:short_id"
            component={AdminAddShortVideo}
          />
          {/**************
           * @DESC UOM Pages
           ***************/}
          <AdminPrivateRoute
            exact
            path="/superadmin/management-services/adduom"
            component={SuperAdminAddUom}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/management-services/addratio"
            component={SuperAdminAddUomRatio}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/management-services/unitofmanagement"
            component={SuperAdminDisplayUom}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/management-services/uom-ratio"
            component={SuperAdminDisplayUomRatio}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/management-services/edituom/:id"
            component={SuperAdminAddUom}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/management-services/editratio/:id"
            component={SuperAdminAddUomRatio}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/experiencesummaryreports"
            component={ExpSummaryReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/experiencesummaryreports/:id"
            component={ExpVendorReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/experienceactivityreport"
            component={ExpActivityReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/experiencerefundreport"
            component={ExpRefundReport}
          />
          <AdminPrivateRoute
            exact
            path="/superadmin/experiencecancellationreport"
            component={ExpCancellationReport}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/experience-management"
            component={AdminExperienceManagementScreen}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/experience-management/offline"
            component={AdminOfflineExperienceManagement}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/experience-management/offline/special"
            component={AdminSpecialOfflineExperienceManagement}
          />
          <AdminPrivateRoute
            exact
            path="/admin-casual-dining/experience-management/offline/curated"
            component={AdminCuratedOfflineExperienceManagament}
          />

          {/* /****************************************************************
              @DESC Vendor Onboarding Process Link 
            *******************************************************************/}
          <DetailsPrivateRoute
            exact
            path="/subscriptiondescription"
            component={SubscriptionScreenDescription}
          />
          <DetailsPrivateRoute
            exact
            path="/subscription"
            component={MainSubscriptionScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/offers"
            component={CasualDiningOffersManagement}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/scanandpay"
            component={CasualDiningScanAndPayScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/events"
            component={CasualDiningEventManagementScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/event/offline"
            component={OfflineEventsSubscription}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/experience/offline"
            component={OfflineExperienceSubscription}
          />

          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/event/offline/ticketbooking"
            component={TicketBookingPayment}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/event/offline/table"
            component={OfflineEventTableManagementScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/event/offline/tableseatmanagement"
            component={OfflineEventTableSeatManagement}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/event/online"
            component={OnlineEventsSubscription}
          />
          <MerchantDashboardAndOnboardingRoute
            exact
            path="/casual-fine-dining/experience-management"
            component={ExperienceManagementScreen}
          />
          <MerchantDashboardAndOnboardingRoute
            exact
            path="/casual-fine-dining/experience-management/offline"
            component={OfflineExperienceManagement}
          />
          <MerchantDashboardAndOnboardingRoute
            exact
            path="/casual-fine-dining/experience-management/offline/special"
            component={SpecialOfflineExperienceManagement}
          />
          <MerchantDashboardAndOnboardingRoute
            exact
            path="/casual-fine-dining/experience-management/offline/curated"
            component={CuratedOfflineExperienceManagement}
          />

          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/livestreaming"
            component={CasualDiningLiveStreamingScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/seatingmanagement"
            component={CasualDiningSeatingManagementScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/seatingmanagement/generalseating"
            component={GenralSeatingScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/seatingmanagement/walkinwaitlist"
            component={WalkinWaitlistScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/seatingmanagement/reservation"
            component={ReservationSeatingScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/seatingmanagement/table"
            component={TableManagementScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/seatingmanagement/tableseatmanagement"
            component={TableSeatManagement}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/ordering"
            component={CasualDiningOrderingScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/ordering/takeaway"
            component={Takeaway}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/ordering/curbside"
            component={Curbside}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/ordering/dinein"
            component={Dinein}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/ordering/dinein/table"
            component={DineinTableManagementScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/ordering/dinein/tableseatmanagement"
            component={DineinTableSeatManagement}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/ordering/cateringbanquet"
            component={CateringBanquet}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/ordering/cateringbanquet/room"
            component={CateringRoomManagementScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/ordering/cateringbanquet/roomseatmanagement"
            component={CateringRoomSeatManagement}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/ordering/homedelivery"
            component={HomeDelivery}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/ordering/bankaccount"
            component={BankAccount}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/ordering/separatebankaccount"
            component={SeparateBankAccount}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/ordering/generalsettingstaxes"
            component={GeneralSettingsTaxes}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/menusetup"
            component={MenuSetup}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/menusetup/selectmenu/cuisine"
            component={Cuisine}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/menusetup/selectmenu/categorytype"
            component={CategoryType}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/menusetup/crossselling"
            component={CrossSelling}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/menusetup/selectmenu/selectedcategories"
            component={SelectedCategories}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/menusetup/selectmenu/selecteditemsnew"
            component={SelectedItemsNew}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/menusetup/selectmenu/editcategories"
            component={EditCategories}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/menusetup/selectmenu/selectitems"
            component={SelectItems}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/menusetup/selectmenu/selectitemsnew"
            component={SelectItemsNew}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/menusetup/selectmenu/selecteditems"
            component={SelectedItems}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/menusetup/uploadmenu"
            component={UploadMenu}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/menusetup/addcategory"
            component={AddCategories}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/menusetup/addcategory/catalog"
            component={AddCategories}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/menusetup/additem"
            component={AddItem}
          />
          <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/menusetup/additem/catalog"
            component={AddItem}
          />
          {/********************************************
            @DESC FAST FOOD MANAGEMENT SUBSCRIPTION
          ********************************************/}
          <DetailsPrivateRoute
            exact
            path="/fastfood/offers"
            component={FastFoodOffersManagement}
          />
          <MerchantDashboardAndOnboardingRoute
            exact
            path="/fastfood/experience-management"
            component={ExperienceManagementScreen}
          />
          <MerchantDashboardAndOnboardingRoute
            exact
            path="/fastfood/experience-management/offline"
            component={OfflineExperienceManagement}
          />
          <MerchantDashboardAndOnboardingRoute
            exact
            path="/fastfood/experience-management/offline/special"
            component={SpecialOfflineExperienceManagement}
          />
          <MerchantDashboardAndOnboardingRoute
            exact
            path="/fastfood/experience-management/offline/curated"
            component={CuratedOfflineExperienceManagement}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/scanandpay"
            component={FastFoodScanAndPayScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/livestreaming"
            component={FastFoodLiveStreamingScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/ordering"
            component={FastFoodOrderingScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/ordering/takeaway"
            component={FastFoodTakeaway}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/ordering/curbside"
            component={FastFoodCurbside}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/ordering/dinein"
            component={FastFoodDinein}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/ordering/cateringbanquet"
            component={FastFoodCateringBanquet}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/ordering/myseattable"
            component={FastFoodMySeatTable}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/ordering/homedelivery"
            component={FastFoodHomeDelivery}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/ordering/bankaccount"
            component={FastFoodBankAccount}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/ordering/separatebankaccount"
            component={FastFoodSeparateBankAccount}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/ordering/generalsettingstaxes"
            component={FastFoodGeneralSettingsTaxes}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/menusetup"
            component={MenuSetup}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/menusetup/addcategory"
            component={AddCategories}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/menusetup/additem"
            component={AddItem}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/menusetup/selectmenu/cuisine"
            component={FastFoodCuisine}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/menusetup/selectmenu/categorytype"
            component={FastFoodCategoryType}
          />
          {/* <DetailsPrivateRoute
            exact
            path="/fastfood/menusetup/crossselling"
            component={FastFoodCrossSelling}
          /> */}
          <DetailsPrivateRoute
            exact
            path="/fastfood/menusetup/crossselling"
            component={CrossSelling}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/menusetup/selectmenu/selectedcategories"
            component={FastFoodSelectedCategories}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/menusetup/selectmenu/editcategories"
            component={FastFoodEditCategories}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/menusetup/selectmenu/selectitems"
            component={FastFoodSelectItems}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/menusetup/selectmenu/selecteditems"
            component={FastFoodSelectedItems}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/menusetup/uploadmenu"
            component={FastFoodUploadMenu}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/menusetup/addcategory"
            component={FastFoodAddCategories}
          />
          <DetailsPrivateRoute
            exact
            path="/fastfood/menusetup/additem"
            component={FastFoodAddItem}
          />
          {/* <DetailsPrivateRoute
            exact
            path="/casual-fine-dining/seating/table"
            component={TableSeatManagement}
          /> */}
          {/********************************************
            @DESC MULTI SERVICE MANAGEMENT SUBSCRIPTION
          ********************************************/}
          <DetailsPrivateRoute
            exact
            path="/multi-service/offers"
            component={MultiServiceOffersManagement}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/scanandpay"
            component={MultiServiceScanAndPayScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/events"
            component={MultiServiceEventManagementScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/event/offline"
            component={MultiServiceOfflineEventsSubscription}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/event/offline/ticketbooking"
            component={MultiServiceTicketBookingPayment}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/event/online"
            component={MultiServiceOnlineEventsSubscription}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/livestreaming"
            component={MultiServiceLiveStreamingScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/seatingmanagement"
            component={MultiServiceSeatingManagementScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/seatingmanagement/generalseating"
            component={MultiServiceGenralSeatingScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/seatingmanagement/walkinwaitlist"
            component={MultiServiceWalkinWaitlistScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/seatingmanagement/reservation"
            component={MultiServiceReservationSeatingScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/seatingmanagement/table"
            component={MultiServiceTableManagementScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/seatingmanagement/tableseatmanagement"
            component={MultiServiceTableSeatManagement}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/ordering"
            component={MultiServiceOrderingScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/ordering/takeaway"
            component={MultiServiceTakeaway}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/ordering/curbside"
            component={MultiServiceCurbside}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/ordering/dinein"
            component={MultiServiceDinein}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/ordering/skiptheline"
            component={MultiServiceSkipTheLine}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/ordering/atmyseattable"
            component={MultiServiceAtMySeatTable}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/ordering/dinein/table"
            component={MultiServiceDineinTableManagementScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/ordering/dinein/tableseatmanagement"
            component={MultiServiceDineinTableSeatManagement}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/ordering/cateringbanquet"
            component={MultiServiceCateringBanquet}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/ordering/cateringbanquet/room"
            component={MultiServiceCateringRoomManagementScreen}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/ordering/cateringbanquet/roomseatmanagement"
            component={MultiServiceCateringRoomSeatManagement}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/ordering/homedelivery"
            component={MultiServiceHomeDelivery}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/ordering/bankaccount"
            component={MultiServiceBankAccount}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/ordering/separatebankaccount"
            component={MultiServiceSeparateBankAccount}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/ordering/generalsettingstaxes"
            component={MultiServiceGeneralSettingsTaxes}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/menusetup"
            component={MenuSetup}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/menusetup/selectmenu/cuisine"
            component={Cuisine}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/menusetup/selectmenu/categorytype"
            component={CategoryType}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/menusetup/crossselling"
            component={CrossSelling}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/menusetup/selectmenu/selectedcategories"
            component={SelectedCategories}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/menusetup/selectmenu/selecteditemsnew"
            component={SelectedItemsNew}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/menusetup/selectmenu/editcategories"
            component={EditCategories}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/menusetup/selectmenu/selectitems"
            component={SelectItems}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/menusetup/selectmenu/selectitemsnew"
            component={SelectItemsNew}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/menusetup/selectmenu/selecteditems"
            component={SelectedItems}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/menusetup/uploadmenu"
            component={UploadMenu}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/menusetup/addcategory"
            component={AddCategories}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/menusetup/addcategory/catalog"
            component={AddCategories}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/menusetup/additem"
            component={AddItem}
          />
          <DetailsPrivateRoute
            exact
            path="/multi-service/menusetup/additem/catalog"
            component={AddItem}
          />
          <MerchantDashboardAndOnboardingRoute
            exact
            path="/multi-service/experience-management"
            component={ExperienceManagementScreen}
          />
          <MerchantDashboardAndOnboardingRoute
            exact
            path="/multi-service/experience-management/offline"
            component={OfflineExperienceManagement}
          />
          <MerchantDashboardAndOnboardingRoute
            exact
            path="/multi-service/experience-management/offline/special"
            component={SpecialOfflineExperienceManagement}
          />
          <MerchantDashboardAndOnboardingRoute
            exact
            path="/multi-service/experience-management/offline/curated"
            component={CuratedOfflineExperienceManagement}
          />
          {/* End MULTI SERVICE ROUTES */}
          <DetailsPrivateRoute
            exact
            path="/subscriptionhome"
            component={MainSubscriptionComponent}
          />
          <DetailsPrivateRoute
            exact
            path="/bankdetailshome"
            component={BankAndOtherDetails}
          />
          <DetailsPrivateRoute
            exact
            path="/businesshours"
            component={MainBusinessHours}
          />
          <DetailsPrivateRoute
            exact
            path="/multicuisine"
            component={CuisineOfferedComponent}
          />
          <DetailsPrivateRoute
            exact
            path="/foodtype"
            component={FoodTypeComponent}
          />
          <DetailsPrivateRoute
            exact
            path="/cuisinesetup"
            component={CuisineSetupOnboarding}
          />
          <DetailsPrivateRoute
            exact
            path="/serviceoffered"
            component={ServicesOfferedOnboarding}
          />
          <DetailsPrivateRoute
            exact
            path="/othresfeatures"
            component={OtherFeaturesOnboarding}
          />
          <DetailsPrivateRoute
            exact
            path="/accessibility"
            component={AccessibilityOnboardingComponent}
          />
          <DetailsPrivateRoute
            exact
            path="/parking"
            component={ParkingMethodOnboarding}
          />
          <DetailsPrivateRoute
            exact
            path="/healthsenitation"
            component={HealthAndSenitationOnboardingComponent}
          />
          <DetailsPrivateRoute
            exact
            path="/locatedinside"
            component={LocatedInsideOnboarding}
          />
          <DetailsPrivateRoute
            exact
            path="/pointofsale"
            component={PointOfSaleComponent}
          />
          <DetailsPrivateRoute exact path="/poswithid" component={PosWithId} />
          <DetailsPrivateRoute
            exact
            path="/createcustommenuonboard"
            component={CreateCustomMenuOnboard}
          />
          <DetailsPrivateRoute
            exact
            path="/petsallowed"
            component={PetsAllowedComponent}
          />
          <DetailsPrivateRoute
            exact
            path="/dresscodetype"
            component={DressCodeOnboarding}
          />
          <DetailsPrivateRoute
            exact
            path="/paymenttype"
            component={PaymentMethodOnboarding}
          />
          <DetailsPrivateRoute
            exact
            path="/restauranttype"
            component={RestaurantTypeComponent}
          />
          <DetailsPrivateRoute
            exact
            path="/restaurantchains"
            component={RestaurantChainsOnboardingComponent}
          />
          <DetailsPrivateRoute
            exact
            path="/restaurantInfo"
            component={RestaurantDetailsLogoVideo}
          />
          <DetailsPrivateRoute
            exact
            path="/pointofcontacts"
            component={PointOfContactsComponent}
          />
          <DetailsPrivateRoute
            exact
            path="/restaurantsettings"
            component={RestaurantDetailsSettings}
          />
          <DetailsPrivateRoute
            exact
            path="/map-setup-two"
            component={MapSetupScreenTwo}
          />
          <DetailsPrivateRoute
            exact
            path="/notautodetectmap"
            component={NoMapSetupComponent}
          />
          <DetailsPrivateRoute
            exact
            path="/mapsetup"
            component={MapSetupScreenOne}
          />
          <DetailsPrivateRoute
            exact
            path="/createcustommenu"
            component={vendorDashboardCreateMenu}
          />
          <DetailsPrivateRoute
            exact
            path="/termcondition"
            component={TermsAndCondition}
          />
          <Route exact path="/passwordreset" component={ResetPasswordSuccess} />
          <Route exact path="/help" component={HelpPageComponent} />
          <Route exact path="/resetpassword" component={ResetPassword} />
          <Route exact path="/otp" component={Otp} />
          <Route exact path="/forgotpassword" component={ForgotPassword} />
          <Route exact path="/signup" component={SignUp} />
          <Route exact path="/" component={Login} />
          <Route exact path="/admin-login" component={AdminLogin} />
          <Route exact path="/authentication" component={AdminOtpComponent} />
          {/*  Public Routes  */}
          <PublicRoute
            exact
            path="/ticketbooked/:id"
            component={EventQrCodePublicDisplay}
          />
          <PublicRoute
            exact
            path="/experience/ticket/:id"
            component={ExperienceQrCodePublicDisplay}
          />
          {/* 404 NOT FOUND */}
          <PrivateRoute exact path="*" component={PageNotFound} />
        </Switch>
      </Fragment>
    </>
  );
};

export default Routes;
